
        const css = "/**\n * Generated by scripts/build-css.js - do not edit.\n * Pruned design tokens (used by gnav) + global navigation CSS.\n */\n\n:root {\n  --s2a-color-gray-25: #fff;\n  --s2a-color-gray-50: #f8f8f8;\n  --s2a-color-gray-75: #f3f3f3;\n  --s2a-color-gray-300: #dadada;\n  --s2a-color-gray-400: #c6c6c6;\n  --s2a-color-gray-700: #505050;\n  --s2a-color-gray-800: #292929;\n  --s2a-color-gray-900: #131313;\n  --s2a-color-gray-1000: #000;\n  --s2a-color-blue-100: #f5f9ff;\n  --s2a-color-blue-200: #e5f0fe;\n  --s2a-color-blue-800: #4b75ff;\n  --s2a-color-blue-900: #3b63fb;\n  --s2a-color-red-900: #d73220;\n  --s2a-color-transparent-black-64: rgb(0 0 0 / 64%);\n  --s2a-color-brand-adobe-red: #eb1000;\n  --s2a-border-radius-0: 0;\n  --s2a-border-radius-2: 2px;\n  --s2a-border-radius-4: 4px;\n  --s2a-border-radius-8: 8px;\n  --s2a-border-radius-12: 12px;\n  --s2a-border-radius-16: 16px;\n  --s2a-border-radius-24: 24px;\n  --s2a-border-radius-32: 32px;\n  --s2a-border-radius-999: 999px;\n  --s2a-border-width-1: 1px;\n  --s2a-border-width-2: 2px;\n  --s2a-border-width-4: 4px;\n  --s2a-opacity-32: 32px;\n  --s2a-opacity-48: 48px;\n  --s2a-opacity-64: 64px;\n  --s2a-spacing-0: 0;\n  --s2a-spacing-2: 2px;\n  --s2a-spacing-4: 4px;\n  --s2a-spacing-8: 8px;\n  --s2a-spacing-12: 12px;\n  --s2a-spacing-16: 16px;\n  --s2a-spacing-20: 20px;\n  --s2a-spacing-24: 24px;\n  --s2a-spacing-32: 32px;\n  --s2a-spacing-40: 40px;\n  --s2a-spacing-48: 48px;\n  --s2a-spacing-64: 64px;\n  --s2a-spacing-80: 80px;\n  --s2a-spacing-96: 96px;\n  --s2a-spacing-124: 124px;\n  --s2a-spacing-160: 160px;\n  --s2a-spacing-240: 240px;\n  --s2a-font-family-adobe-clean: \"Adobe Clean\";\n  --s2a-font-family-adobe-clean-display: \"Adobe Clean Display\";\n  --s2a-font-letter-spacing-0: 0;\n  --s2a-font-letter-spacing-neg-3_84: -3.84px;\n  --s2a-font-letter-spacing-neg-3_2: -3.2px;\n  --s2a-font-letter-spacing-neg-2_88: -2.88px;\n  --s2a-font-letter-spacing-neg-1_68: -1.68px;\n  --s2a-font-letter-spacing-neg-1_44: -1.44px;\n  --s2a-font-letter-spacing-neg-1_2: -1.2px;\n  --s2a-font-letter-spacing-neg-0_96: -0.96px;\n  --s2a-font-letter-spacing-neg-0_48: -0.48px;\n  --s2a-font-letter-spacing-neg-0_2: -0.2px;\n  --s2a-font-letter-spacing-0_16: 0.16px;\n  --s2a-font-letter-spacing-0_24: 0.24px;\n  --s2a-font-line-height-16: 1.333;\n  --s2a-font-line-height-18: 1.286;\n  --s2a-font-line-height-20: 1.25;\n  --s2a-font-line-height-24: 1.2;\n  --s2a-font-line-height-32: 1.143;\n  --s2a-font-line-height-40: 1.111;\n  --s2a-font-line-height-48: 1.2;\n  --s2a-font-line-height-56: 1.167;\n  --s2a-font-line-height-69: 1.232;\n  --s2a-font-line-height-76: 1.188;\n  --s2a-font-line-height-92: 1.278;\n  --s2a-font-size-12: 0.75rem;\n  --s2a-font-size-14: 0.875rem;\n  --s2a-font-size-16: 1rem;\n  --s2a-font-size-18: 1.125rem;\n  --s2a-font-size-20: 1.25rem;\n  --s2a-font-size-24: 1.5rem;\n  --s2a-font-size-32: 2rem;\n  --s2a-font-size-40: 2.5rem;\n  --s2a-font-size-48: 3rem;\n  --s2a-font-size-56: 3.5rem;\n  --s2a-font-size-64: 4rem;\n  --s2a-font-size-72: 4.5rem;\n  --s2a-font-size-80: 5rem;\n  --s2a-font-size-96: 6rem;\n  --s2a-font-weight-adobe-clean-black: 900;\n  --s2a-font-weight-adobe-clean-extrabold: 800;\n  --s2a-font-weight-adobe-clean-bold: 700;\n  --s2a-font-weight-adobe-clean-regular: 400;\n  --s2a-blur-8: 8px;\n  --s2a-blur-16: 16px;\n  --s2a-blur-32: 32px;\n  --s2a-blur-64: 64px;\n  --color-transparent-black-12: rgb(0 0 0 / 12%);\n  --color-transparent-black-16: rgb(0 0 0 / 16%);\n}\n\n:root {\n  --s2a-border-radius-sm: var(--s2a-border-radius-8);\n  --s2a-border-radius-md: var(--s2a-border-radius-16);\n  --s2a-border-radius-round: var(--s2a-border-radius-999);\n  --s2a-border-width-sm: var(--s2a-border-width-1);\n  --s2a-border-width-md: var(--s2a-border-width-2);\n  --s2a-border-width-lg: var(--s2a-border-width-4);\n  --s2a-spacing-2xs: var(--s2a-spacing-4);\n  --s2a-spacing-xs: var(--s2a-spacing-8);\n  --s2a-spacing-sm: var(--s2a-spacing-12);\n  --s2a-spacing-md: var(--s2a-spacing-16);\n  --s2a-spacing-lg: var(--s2a-spacing-24);\n  --s2a-spacing-xl: var(--s2a-spacing-32);\n  --s2a-spacing-2xl: var(--s2a-spacing-40);\n  --s2a-spacing-3xl: var(--s2a-spacing-48);\n  --s2a-spacing-4xl: var(--s2a-spacing-64);\n  --s2a-font-family-heading: var(--s2a-font-family-adobe-clean-display);\n  --s2a-font-size-xs: var(--s2a-font-size-12);\n  --s2a-font-size-sm: var(--s2a-font-size-14);\n  --s2a-font-size-md: var(--s2a-font-size-16);\n  --s2a-font-size-xl: var(--s2a-font-size-20);\n  --s2a-font-size-2xl: var(--s2a-font-size-24);\n  --s2a-blur-sm: var(--s2a-blur-16);\n}\n\n:root[data-theme=\"light\"] {\n  --s2a-color-content-default: var(--s2a-color-gray-800);\n  --s2a-color-content-subtle: var(--s2a-color-gray-700);\n  --s2a-color-content-body-subtle: var(--s2a-color-transparent-black-64);\n}\n\n/* ========== Gnav component styles ========== */\n\n/**\n * Global Navigation Styles\n * Styles for the federal global navigation component\n */\n\n/* =========================================\n   Skip to Main Content Link\n   ========================================= */\n\n.feds-skip-link {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n}\n\n.trap-focus-gnav {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n  display: none;\n}\n\nnav:has(.feds-menu-active) .trap-focus-gnav {\n  display: block;\n}\n\n.feds-skip-link:focus {\n  outline: 2px solid var(--s2a-color-blue-800);\n  outline-offset: 1px;\n}\n\n/* =========================================\n   Header Shell\n   ========================================= */\n:root {\n  --feds-font-family: var(--s2a-font-family-adobe-clean), adobe-clean, \"Trebuchet MS\", sans-serif;\n  --feds-heading-font-family: \"Adobe Clean Display Black\", var(--s2a-font-family-heading), adobe-clean-display, \"Arial Bold Adjusted\", sans-serif;\n  --s2a-typography-line-height-title-4-temp: 1;\n}\n\n\nheader.global-navigation {\n  width: 100%;\n  background: transparent;\n  visibility: visible;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  /* right: 0;\n  max-width: var(--grid-max-width-default);\n  margin: auto; */\n}\n\nheader.feds-header-scrolled .feds-link {\n  color: var(--s2a-color-gray-1000);\n}\n\nheader.feds-header-scrolled nav {\n  color: var(--s2a-color-gray-1000);\n  box-shadow: 0 67px 19px 0 rgba(0, 0, 0, 0.00), 0 43px 17px 0 rgba(0, 0, 0, 0.01), 0 24px 14px 0 rgba(0, 0, 0, 0.04), 0 11px 11px 0 rgba(0, 0, 0, 0.07), 0 3px 6px 0 rgba(0, 0, 0, 0.08);\n}\n\n.global-navigation.site-pivot .universal-nav-container .profile-signed-out button {\n  color: var(--s2a-color-gray-1000);\n  border: 1px solid var(--s2a-color-gray-25);\n  background-color: var(--s2a-color-gray-25);\n}\n\n.global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .universal-nav-container .profile-signed-out button {\n  color: inherit;\n  border-color: var(--s2a-color-gray-1000);\n  background-color: transparent;\n}\n\n.global-navigation.site-pivot.feds-header-scrolled .universal-nav-container .profile-signed-out button:hover,\n.global-navigation.site-pivot.feds-header-scrolled .universal-nav-container .profile-signed-out button:focus-visible {\n  color: inherit;\n  background-color: var(--s2a-color-gray-25);\n}\n\n.global-navigation.site-pivot .universal-nav-container #universal-nav {\n  justify-content: flex-end;\n}\n\n.global-navigation.site-pivot .feds-utilities {\n  margin-left: auto;\n  padding-right: var(--s2a-spacing-md);\n}\n\n::backdrop {\n  opacity: 1;\n}\n\n.global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link {\n  cursor: pointer;\n}\n\n/* =========================================\n   Navigation Bar\n   ========================================= */\n\n.global-navigation.site-pivot nav {\n  display: flex;\n  align-items: center;\n  height: var(--s2a-spacing-64);\n  width: calc(100% - 2 * var(--s2a-spacing-xs));\n  justify-content: flex-start;\n}\n\nheader.global-navigation nav {\n  position: fixed;\n  inset:\n    var(--s2a-spacing-xs)\n    var(--s2a-spacing-xs)\n    0\n    var(--s2a-spacing-xs);\n  width: calc(100% - var(--s2a-spacing-xs) * 2);\n  max-width: calc(1920px - var(--s2a-spacing-xs) * 2);\n  margin: 0 auto;\n  border: none;\n  padding: 0;\n  overflow: visible;\n  border-radius: var(--s2a-border-radius-16);\n\n  background-color: transparent;\n}\n\nheader.global-navigation nav::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  background-color: transparent;\n  backdrop-filter: blur(0px);\n  border-radius: var(--s2a-border-radius-16);\n  z-index: -1;\n  transition: all 0.48s cubic-bezier(0.42, 0, 0.2, 1),\n              height 0.35s ease;\n}\n\nheader.global-navigation.feds-header-scrolled nav::after {\n  backdrop-filter: blur(var(--s2a-blur-sm));\n}\n\nheader.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {\n  width: 100vw;\n  border-radius: 0 0 var(--s2a-border-radius-16) var(--s2a-border-radius-16);\n  background-color: var(--s2a-color-gray-75);\n  left: calc(0px - var(--s2a-spacing-xs));\n  top: calc(0px - var(--s2a-spacing-xs) * 2);\n  backdrop-filter: blur(0px);\n}\n\n@media (max-width: 1023px) {\n  header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {\n    height: calc(100dvh + var(--s2a-spacing-xs));\n  }\n}\n\nheader.global-navigation.feds-header-scrolled nav::after {\n  background-color: rgba(255, 255, 255, 0.51);\n}\n\n.global-navigation nav > ul {\n  display: flex;\n  width: 100%;\n  max-width: 1200px;\n  height: inherit;\n  align-items: center;\n  padding-left: 0;\n}\n\n.global-navigation nav > ul > li {\n  display: flex;\n  align-items: center;\n}\n\n.global-navigation.site-pivot ul {\n  list-style: none;\n  margin: 0;\n}\n\n/* =========================================\n   Nav Links\n   ========================================= */\n\n.feds-link {\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  font-family: var(--feds-font-family);\n  font-size: var(--s2a-typography-font-size-body-sm);\n  line-height: var(--s2a-typography-line-height-body-sm);\n  letter-spacing: var(--s2a-typography-letter-spacing-body-sm);\n  display: flex;\n  align-items: center;\n  border: 0;\n  background-color: transparent;\n  padding: var(--s2a-spacing-sm);\n  color: var(--s2a-color-gray-25);\n  opacity: 1;\n  text-decoration: none;\n}\n\n.feds-link:hover {\n  text-decoration: underline;\n}\n\n.global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link {\n  color: var(--s2a-color-gray-1000);\n  font-size: var(--s2a-typography-font-size-title-2);\n  line-height: var(--s2a-typography-line-height-title-2);\n  letter-spacing: var(--s2a-typography-letter-spacing-title-2);\n  padding: var(--s2a-spacing-xs) 0;\n}\n\n.global-navigation .feds-gnav-items > li > .feds-link:hover {\n  text-decoration: none;\n  opacity: 1;\n  color: var(--s2a-color-gray-25);\n}\n\n.global-navigation.feds-header-scrolled .feds-gnav-items > li > .feds-link:hover {\n  color: var(--s2a-color-gray-1000);\n}\n\n\n\n/* =========================================\n   Nav Toggle (Hamburger)\n   ========================================= */\n\n.global-navigation nav .feds-nav-toggle {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  color: var(--s2a-color-gray-25);\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--s2a-font-size-xl);\n  /* No token: font-weight 300 */\n  font-weight: 300;\n}\n\n.global-navigation nav .feds-nav-toggle svg {\n  width: 14px;\n  height: 7px;\n  flex-shrink: 0;\n  color: var(--s2a-color-gray-25);\n}\n\n.global-navigation.feds-header-scrolled nav .feds-nav-toggle svg {\n  color: var(--s2a-color-gray-1000);\n}\n\n/* =========================================\n   Utilities (App Switcher, Profile)\n   ========================================= */\n\n.global-navigation .unav-comp-app-switcher.unav-comp-icon svg,\n.global-navigation .unav-comp-external-notifications svg path,\n.global-navigation .unav-comp-cart svg {\n  fill: var(--s2a-color-gray-25);\n}\n\n.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .unav-comp-app-switcher.unav-comp-icon svg,\n.global-navigation .unav-comp-app-switcher.unav-comp-icon.unav-comp-app-switcher-open svg,\n.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .unav-comp-cart svg {\n  fill: var(--s2a-color-gray-1000);\n}\n\n.global-navigation.feds-header-scrolled .unav-comp-app-switcher.unav-comp-icon svg,\n.global-navigation.feds-header-scrolled .unav-comp-external-notifications svg path,\n.global-navigation.feds-header-scrolled .unav-comp-cart svg {\n  fill: var(--s2a-color-gray-1000);\n}\n\n.global-navigation .unav-comp-app-switcher.unav-comp-icon:hover svg,\n.global-navigation .unav-comp-app-switcher.unav-comp-icon:focus-visible svg,\n.global-navigation .unav-comp-external-notifications:hover svg path,\n.global-navigation .unav-comp-cart:hover svg,\n.global-navigation .unav-comp-cart:focus-visible svg {\n  fill: var(--s2a-color-gray-1000);\n}\n\n.global-navigation.feds-header-scrolled .universal-nav-container .profile-signed-out button {\n  color: var(--s2a-color-gray-1000);\n  border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);\n  background-color: transparent;\n}\n\nheader.global-navigation:has(.feds-popup:popover-open) .unav-comp-app-switcher.unav-comp-icon svg,\nheader.global-navigation:has(.feds-popup:popover-open) .unav-comp-external-notifications svg path,\nheader.global-navigation:has(.feds-popup:popover-open) .unav-comp-cart svg {\n  fill: inherit;\n}\n\nheader.global-navigation:has(.feds-popup:popover-open) .unav-comp-tooltip {\n  display:none !important;\n}\n\n/* =========================================\n   Popup (Mega Menu Container)\n   ========================================= */\n\n.feds-popup {\n  position: fixed;\n  inset: calc(var(--s2a-spacing-64) + var(--s2a-spacing-8) - 1px) 0 auto 0;\n  width: 100%;\n  max-width: none;\n  max-height: calc(100dvh - var(--s2a-spacing-64));\n  margin: 0;\n  border: 0;\n  padding: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n  background-color:transparent;\n}\n\n.feds-popup:popover-open {\n  display: block;\n  /* No token for 18px */\n  border-bottom-left-radius: 18px;\n  border-bottom-right-radius: 18px;\n}\n\n.feds-popup > * {\n  width: min(1200px, 100%);\n  box-sizing: border-box;\n}\n\n.feds-popup .feds-popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--s2a-spacing-xs) var(--s2a-spacing-lg);\n}\n\n.feds-popup .feds-popup-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.feds-popup .feds-popup-back-button {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--s2a-color-content-default);\n  cursor: pointer;\n}\n\n.feds-popup .feds-popup-back-button svg {\n  width: var(--s2a-spacing-20);\n  height: var(--s2a-spacing-20);\n}\n\n.feds-popup .feds-popup-back-button .feds-popup-title {\n  font-size: var(--s2a-typography-font-size-title-2);\n  line-height: var(--s2a-typography-line-height-title-2);\n  letter-spacing: var(--s2a-typography-letter-spacing-title-2);\n  font-weight: var(--s2a-font-weight-adobe-clean-black);\n  font-family: var(--feds-heading-font-family);\n  color: var(--s2a-color-content-default);\n  margin-left: 10px; /* replace with token if we find one later */\n}\n\n/* =========================================\n   Link Groups\n   ========================================= */\n\n.feds-popup .feds-product-card {\n  display: grid;\n  grid-template-columns: var(--s2a-spacing-xl) minmax(0, 1fr);\n  gap: var(--s2a-spacing-lg);\n  min-height: 52px;\n  align-items: start;\n  border-radius: var(--s2a-border-radius-md);\n  padding: var(--s2a-spacing-lg);\n  text-decoration: none;\n  color: var(--s2a-color-content-default);\n}\n\n.feds-popup .feds-product-card:hover .feds-product-card__title,\n.feds-popup .feds-product-card:hover .feds-product-card__subtitle {\n  color: var(--s2a-color-gray-25);\n}\n\n.feds-popup .feds-product-card__icon {\n  display: block;\n  width: var(--s2a-spacing-lg);\n  height: var(--s2a-spacing-lg);\n  margin-top: var(--s2a-spacing-2xs);\n}\n\n.feds-popup .feds-product-card__icon-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.feds-popup .feds-product-card__title {\n  font-weight: var(--s2a-font-weight-adobe-clean-black);\n  font-size: var(--s2a-typography-font-size-title-4);\n  line-height: var(--s2a-typography-line-height-title-4-temp);\n  letter-spacing: var(--s2a-typography-letter-spacing-title-4);\n  font-family: var(--feds-heading-font-family);\n}\n\n.feds-popup .feds-product-card__badges {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-bottom: var(--s2a-spacing-xs);\n}\n\n.feds-popup .feds-product-card__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);\n  border-radius: var(--s2a-border-radius-sm);\n  font-size: var(--s2a-font-size-xs);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: var(--s2a-typography-line-height-caption);\n  color: var(--s2a-color-gray-1000);\n  letter-spacing: var(--s2a-typography-letter-spacing-caption);\n}\n\n.feds-popup .feds-product-card__badge--filled {\n  border-color: var(--s2a-color-gray-1000);\n  background: var(--s2a-color-gray-1000);\n  color: var(--s2a-color-gray-25);\n}\n\n.feds-popup .feds-product-card__subtitle {\n  margin-top: var(--s2a-spacing-2xs);\n  font-size: var(--s2a-typography-font-size-body-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-regular);\n  line-height: var(--s2a-typography-line-height-body-sm);\n  letter-spacing: var(--s2a-typography-letter-spacing-body-sm);\n  color: var(--s2a-color-content-body-subtle);\n}\n\n.feds-popup .feds-product-card__price {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin-top: var(--s2a-spacing-sm);\n}\n\n.feds-popup .feds-product-card__old-price {\n  font-size: var(--s2a-font-size-xs);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: 1;\n  text-decoration: line-through;\n  /* No token: design uses custom gray */\n  color: var(--s2a-color-content-subtle);\n}\n\n.feds-popup .feds-product-card__new-price {\n  font-size: var(--s2a-font-size-xs);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: 1;\n  color: var(--s2a-color-gray-1000);\n}\n\n.feds-popup .feds-product-card--blue {\n  background: var(--s2a-color-blue-100);\n}\n\n.feds-popup .feds-product-card--blue:hover {\n  background: var(--s2a-color-blue-200);\n}\n\n.feds-popup .feds-product-card:hover .feds-product-card__old-price,\n.feds-popup .feds-product-card:hover .feds-product-card__new-price,\n.feds-popup .feds-product-card:hover .feds-product-card__badge {\n  color: var(--s2a-color-gray-25);\n  border-color: var(--s2a-color-gray-25);\n}\n\n.feds-popup .feds-product-card:hover .feds-product-card__badge--filled {\n  background: var(--s2a-color-gray-25);\n  color: var(--s2a-color-gray-1000);\n}\n\n.feds-product-card .feds-product-card-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\n/* =========================================\n   Secondary CTAs\n   ========================================= */\n\n.feds-popup .feds-secondary-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 11px 14px 10px;\n  border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);\n  border-radius: var(--s2a-border-radius-round);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  font-size: var(--s2a-typography-font-size-body-sm);\n  line-height: var(--s2a-typography-line-height-body-sm);\n  letter-spacing: var(--s2a-typography-letter-spacing-body-sm);\n  color: var(--s2a-color-content-default);\n  text-decoration: none;\n}\n\n.feds-popup .feds-secondary-cta:hover {\n  background: var(--s2a-color-gray-75);\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  .global-navigation nav .feds-nav-toggle {\n    display: none;\n  }\n\n  .global-navigation nav > ul > li.feds-menu-wrapper {\n    position: static;\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    width: auto;\n    height: unset;\n    border: 0;\n    outline: 0;\n    box-shadow: none;\n    justify-content: space-between;\n    background-color: transparent;\n    opacity: 1;\n    visibility: visible;\n    translate: unset;\n    transition: unset;\n  }\n\n  .global-navigation.site-pivot nav {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .global-navigation nav .feds-gnav-items {\n    align-items: center;\n    padding-left: 0;\n    margin: 0;\n    display: flex;\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .feds-link {\n    letter-spacing: var(--s2a-typography-letter-spacing-label);\n  }\n  .global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link {\n    opacity: 60%;\n    font-weight: var(--s2a-font-weight-adobe-clean-bold);\n    font-size: var(--s2a-typography-font-size-label);\n    line-height: var(--s2a-typography-line-height-label);\n    letter-spacing: var(--s2a-typography-letter-spacing-label);\n    padding: var(--s2a-spacing-sm);\n  }\n\n  .global-navigation.site-pivot:not(:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)) .feds-gnav-items:has(.feds-link:hover) > li > .feds-link:not(:hover) {\n    opacity: 0.65;\n  }\n\n\n  .global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link[aria-expanded=\"true\"],\n  .global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link:hover {\n    opacity: 1;\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link {\n    position: relative;\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link .chevron-down {\n    margin-top: 3px;\n    margin-left: 6px;\n    flex-shrink: 0;\n    transition: transform 0.15s ease;\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link:has(~ .feds-popup:popover-open) .chevron-down {\n    transform: rotate(180deg);\n  }\n\n  .feds-popup .feds-popup-header {\n    display: none;\n  }\n\n  .feds-popup > div {\n    max-width: 1920px;\n  }\n  .feds-popup .feds-product-card__title {\n    font-weight: var(--s2a-font-weight-adobe-clean-bold);\n    font-size: var(--s2a-typography-font-size-eyebrow);\n    line-height: var(--s2a-typography-line-height-eyebrow);\n    letter-spacing: var(--s2a-typography-letter-spacing-eyebrow);\n    font-family: var(--feds-font-family);\n  }\n}\n\n/* =========================================\n   Responsive: Mobile (max-width: 1023px)\n   ========================================= */\n\n@media (max-width: 1023px) {\n  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link {\n    width: 100%;\n    justify-content: space-between;\n    text-align: left;\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .feds-link {\n    font-family: var(--feds-heading-font-family);\n    font-weight: var(--s2a-font-weight-adobe-clean-black);\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link .chevron-down {\n    order: 2;\n    margin-left: var(--s2a-spacing-xs);\n    flex-shrink: 0;\n    transform: rotate(-90deg) scale(2.5);\n  }\n\n  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link .chevron-down path {\n    stroke-width: 0.5;\n  }\n\n  .feds-popup {\n    inset: calc(var(--s2a-spacing-64) + var(--s2a-spacing-8) - 1px) 0 0 0;\n  }\n\n  .feds-popup .feds-product-card {\n    gap: var(--s2a-spacing-2xl);     \n    border-radius: var(--s2a-border-radius-24);\n  }\n\n  body:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) {\n    overflow: hidden;\n    scrollbar-gutter: stable;\n  }\n\n  header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {\n    border-radius: 0;\n  }\n\n  .feds-popup .feds-product-card__subtitle {\n    margin-top: var(--s2a-spacing-xs);\n  }\n}\n\n/* =========================================\n   Scroll Animations\n   ========================================= */\n\n@media (min-width: 1920px) {\n  header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {\n    left: calc(0px - var(--s2a-spacing-xs) - (100vw - 1920px) / 2);\n  }\n\n  header.global-navigation nav .feds-popup > div {\n    margin: 0 auto;\n  }\n}\n\n/* =========================================\n   Popover Animations\n   ========================================= */\n\n\n@media (min-width: 1024px) {\n  .feds-popup {\n    border-bottom-left-radius: 18px;\n    border-bottom-right-radius: 18px;\n    background-color: transparent;\n    opacity: 0;\n    overflow: hidden;\n    max-height: calc(100dvh - var(--s2a-spacing-64));\n    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);\n    transition:\n      display 0.48s allow-discrete,\n      overlay 0.48s allow-discrete,\n      opacity 0.48s cubic-bezier(0.4, 0, 0.2, 1);\n    transition-delay: 0s;\n  }\n\n  .feds-popup:popover-open {\n    background-color: transparent;\n    opacity: 1;\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n    transition-delay: 0.15s;\n  }\n\n  .feds-popup:popover-open > :not(.feds-popup-header) {\n    overflow-y: auto;\n    max-height: calc(100dvh - var(--s2a-spacing-64));\n  }\n\n  @starting-style {\n    .feds-popup:popover-open {\n      background-color: rgba(255,255,255,0.51);\n      opacity: 0;\n      clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);\n    }\n  }\n\n  nav::backdrop {\n    background-color: rgba(0, 0, 0, 0);\n    backdrop-filter: blur(0px);\n    inset: 0 0 0 0;\n    transition:\n      opacity 0.3s ease,\n      background-color 0.3s ease,\n      backdrop-filter 0.3s ease;\n  }\n\n  nav:has(.feds-popup:popover-open)::backdrop {\n    opacity: 1;\n    background-color: rgba(0, 0, 0, 0.60);\n    backdrop-filter: blur(32px);\n  }\n\n  @starting-style {\n    nav::backdrop {\n      opacity: 0;\n      background-color: rgba(0, 0, 0, 0);\n      backdrop-filter: blur(0px);\n    }\n  }\n}\n\n/* =========================================\n   Content Entrance Animations (Desktop Only)\n   ========================================= */\n\n@keyframes feds-slide-up {\n  from {\n    transform: translateY(6px);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n.feds-popup:popover-open {\n  /* Animation Variables */\n  --feds-anim-duration: 0.35s;\n  --feds-anim-panel-delay: 0.18s;\n  --feds-anim-stagger-interval: 25ms;\n  --feds-anim-stagger-start: 0.20s;\n}\n.feds-popup:popover-open .product-list ul[role=\"tabpanel\"] > li {\n  transform: translateY(6px);\n  animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;\n}\n.feds-popup:popover-open .product-list ul[role=\"tabpanel\"] > li {\n  transform: translateY(6px);\n  animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;\n}\n\n@media (min-width: 1024px) {\n\n  /* 1. Pane Content (Base Slide & Fade) */\n  .feds-popup:popover-open > div {\n    transform: translateY(6px);\n    animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;\n    animation-delay: var(--feds-anim-panel-delay);\n  }\n\n  /* 2. Filters and Cards (Staggered) */\n  .feds-popup:popover-open .feds-gnav-cards > li,\n  .feds-popup:popover-open .product-list ul.tabs > li {\n    transform: translateY(6px);\n    animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;\n  }\n\n  .product-list .tab-content [role=\"tabpanel\"] {\n    opacity: 0;\n    transition:\n      display 0.48s allow-discrete,\n      opacity 0.48s cubic-bezier(0.4, 0, 0.2, 1);\n    transition-delay: 0.2s;\n    &[hidden] {\n      transition: unset;\n    }\n  }\n\n  .product-list .tab-content [role=\"tabpanel\"]:not([hidden]) {\n    opacity: 1;\n  }\n\n  @starting-style {\n    .product-list .tab-content [role=\"tabpanel\"]:not([hidden]) {\n      opacity: 0;\n    }\n  }\n}\n/* =========================================\n   Unav App Switcher Fix\n   ========================================= */\n\nheader.global-navigation:has(.unav-comp-app-switcher-open) nav {\n  backdrop-filter: none;\n  transform: none;\n  transition: none;\n  background: transparent;\n}\n\nheader.global-navigation .universal-nav-container .universal-nav-tray .unav-comp-overlay {\n  height: 100vh;\n  width: 100vw;\n}\n\n/* =========================================\n   Menu Wrapper (Mobile Fade In)\n   ========================================= */\n\n@keyframes mobile-main-menu-slide-in {\n  from {\n    opacity: 0;\n    transform: translateX(18px);\n  } to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes main-menu-items-exit {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(-40px);\n  }\n}\n\n@keyframes sub-menu-items-enter {\n  from {\n    opacity: 0;\n    transform: translateX(18px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes sub-menu-items-exit {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(18px);\n  }\n}\n\n@keyframes main-menu-items-re-enter {\n  from {\n    opacity: 0;\n    transform: translateX(-18px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fade-in {\n  from { opacity: 0; display: none; }\n  to   { opacity: 1; display: block; }\n}\n\n@keyframes fade-out {\n  from { opacity: 1; display: block; }\n  to   { opacity: 0; display: none; }\n}\n\n@media (max-width: 1023px) {\n  .global-navigation nav > ul > li.feds-menu-wrapper {\n    position: fixed;\n    top: var(--s2a-spacing-64);\n    left: 0;\n    right: var(--s2a-spacing-20);\n    flex-direction: column;\n    height: calc(100dvh - var(--s2a-spacing-64));\n    border: 0;\n    width: 100%;\n    opacity: 0;\n    display: flex;\n    visibility: hidden;\n    color: var(--s2a-color-gray-1000);\n    background-color: transparent;\n    padding: 0;\n  }\n  \n  .global-navigation nav > ul > li.feds-menu-wrapper.feds-menu-active {\n    transition: opacity 0.2s ease, visibility 0s linear 0.2s;\n  }\n  \n  .global-navigation nav > ul > li.feds-menu-wrapper:popover-open {\n    display: flex;\n    translate: 0;\n    opacity: 1;\n    z-index: 2;\n    transition: translate 0.4s ease-out, opacity 0.4s ease, visibility 0s linear 0s;\n    visibility: visible;\n    align-items: flex-start;\n    padding: 0;\n    margin-top: 0;\n  }\n  \n  .global-navigation nav > ul > li.feds-menu-wrapper:popover-open .feds-gnav-items {\n    align-items: flex-start;\n    padding: var(--s2a-spacing-xs) var(--s2a-spacing-lg) var(--s2a-spacing-sm);\n    width: calc(100% - var(--s2a-spacing-3xl));\n  }\n\n  .global-navigation nav > ul > li.feds-menu-wrapper:popover-open {\n    & .feds-gnav-items > li {\n      opacity: 0;\n      transform: translateX(18px);\n      animation: mobile-main-menu-slide-in 0.35s cubic-bezier(0.42, 0, 0, 1) forwards;\n    }\n  \n    & .feds-gnav-items > li:nth-child(1) { animation-delay: 0.18s; }\n    & .feds-gnav-items > li:nth-child(2) { animation-delay: 0.24s; }\n    & .feds-gnav-items > li:nth-child(3) { animation-delay: 0.30s; }\n    & .feds-gnav-items > li:nth-child(4) { animation-delay: 0.36s; }\n    & .feds-gnav-items > li:nth-child(5) { animation-delay: 0.42s; }\n    & .feds-gnav-items > li:nth-child(6) { animation-delay: 0.48s; }\n    & .feds-gnav-items > li:nth-child(7) { animation-delay: 0.54s; }\n    & .feds-gnav-items > li:nth-child(8) { animation-delay: 0.60s; }\n    & .feds-gnav-items > li:nth-child(9) { animation-delay: 0.66s; }\n    & .feds-gnav-items > li:nth-child(10) { animation-delay: 0.72s; }\n  }\n\n  .feds-nav-toggle path {\n    transform-origin: 7px 3.5px;\n    transition: transform 0.35s cubic-bezier(.4,0,.2,1);\n  }\n  \n  .global-navigation:has(.feds-menu-wrapper:popover-open, .feds-popup:popover-open) .feds-nav-toggle svg {\n    height: 11px;\n  }\n  \n  .global-navigation:has(.feds-menu-wrapper:popover-open, .feds-popup:popover-open) .feds-nav-toggle path:first-child {\n    transform: translateY(-2.75px) rotate(-45deg) scaleX(1.25);\n  }\n  .global-navigation:has(.feds-menu-wrapper:popover-open, .feds-popup:popover-open) .feds-nav-toggle path:last-child {\n    transform: translateY(2.75px) rotate(45deg) scaleX(1.25);\n  }\n  \n  header.global-navigation > nav > ul > li.feds-menu-wrapper > ul.feds-gnav-items {\n    /* open subscreen */\n    &.subscreen-opening {\n      & > li {\n        opacity: 1;\n        transform: translateX(0);\n        animation: main-menu-items-exit 0.5s cubic-bezier(0.42, 0, 0, 1) forwards;\n      }\n      & > li:nth-child(1) { animation-delay: 0s; }\n      & > li:nth-child(2) { animation-delay: 0.025s; }\n      & > li:nth-child(3) { animation-delay: 0.05s; }\n      & > li:nth-child(4) { animation-delay: 0.075s; }\n      & > li:nth-child(5) { animation-delay: 0.1s; }\n  \n      /* target the popover descendant when it is open */\n      & .feds-popup:popover-open {\n        opacity: 0;\n        animation: fade-in 0s linear 0.3s forwards; /* zero-duration instant jump after delay */\n  \n        & .feds-popup-header {\n          opacity: 0;\n          transform: translateX(18px);\n          animation: sub-menu-items-enter 0.5s forwards cubic-bezier(0.42, 0, 0, 1) 0.3s;\n        }\n  \n        & .tabs {\n          opacity: 0;\n          transform: translateX(18px);\n          animation: sub-menu-items-enter 0.5s forwards cubic-bezier(0.42, 0, 0, 1);\n          animation-delay: 0.36s;\n        }\n  \n        & .feds-gnav-cards > li {\n          opacity: 0;\n          transform: translateX(18px);\n          animation: sub-menu-items-enter 0.5s forwards cubic-bezier(0.42, 0, 0, 1);\n        }\n        & .feds-gnav-cards > li:nth-child(1) { animation-delay: 0.36s; }\n        & .feds-gnav-cards > li:nth-child(2) { animation-delay: 0.42s; }\n      }\n    }\n    /* close subscreen */\n    &.subscreen-closing {\n      & > li {\n        opacity: 0;\n        transform: translateX(-18px);\n        animation: main-menu-items-re-enter 0.26s ease forwards 0.24s;\n      }\n      & > li:nth-child(1) { animation-delay: 0.24s; }\n      & > li:nth-child(2) { animation-delay: 0.27s; }\n      & > li:nth-child(3) { animation-delay: 0.30s; }\n      & > li:nth-child(4) { animation-delay: 0.33s; }\n      & > li:nth-child(5) { animation-delay: 0.36s; }\n  \n      /* target the popover descendant when it is open */\n      & .feds-popup:popover-open {\n        & .feds-popup-header {\n          opacity: 1;\n          transform: translateX(0px);\n          animation: sub-menu-items-exit 0.2s forwards ease;\n        }\n  \n        & .tabs {\n          opacity: 1;\n          transform: translateX(0px);\n          animation: sub-menu-items-exit 0.2s forwards ease;\n        }\n  \n        & .feds-gnav-cards > li {\n          opacity: 1;\n          transform: translateX(0px);\n          animation: sub-menu-items-exit 0.2s forwards ease;\n        }\n        & .feds-gnav-cards > li:nth-child(1) { animation-delay: 0.04s; }\n        & .feds-gnav-cards > li:nth-child(2) { animation-delay: 0.08s; }\n      }\n    }\n  }\n\n  header.global-navigation.feds-header-scrolled:has(.unav-comp-app-switcher-open) .feds-brand-image svg,\n  header.global-navigation.feds-header-scrolled:has(.unav-comp-app-switcher-open) .feds-nav-toggle svg {\n    animation: none;\n    color: var(--s2a-color-gray-1000);\n  }\n}\n\nul.feds-gnav-cards,\nul[role=\"tabpanel\"],\n.product-list ul.tabs {\n  & > li:nth-child(1) { animation-delay: 0.025s; }\n  & > li:nth-child(2) { animation-delay: 0.05s; }\n  & > li:nth-child(3) { animation-delay: 0.075s; }\n  & > li:nth-child(4) { animation-delay: 0.1s; }\n  & > li:nth-child(5) { animation-delay: 0.125s; }\n  & > li:nth-child(6) { animation-delay: 0.15s; }\n  & > li:nth-child(7) { animation-delay: 0.175s; }\n  & > li:nth-child(8) { animation-delay: 0.2s; }\n  & > li:nth-child(9) { animation-delay: 0.225s; }\n  & > li:nth-child(10) { animation-delay: 0.25s; }\n}\n\n/* =========================================\n   Brand Container\n   ========================================= */\n\n.feds-brand-container {\n  display: flex;\n  flex-shrink: 0;\n}\n\nli.feds-brand-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\nheader.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) nav .feds-brand-image svg,\nheader.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) nav .feds-nav-toggle svg,\nheader.global-navigation.feds-header-scrolled nav .feds-brand-image svg {\n  color: var(--s2a-color-gray-1000);\n}\n\n/* =========================================\n   Brand\n   ========================================= */\n\n.feds-brand {\n  align-items: center;\n  outline-offset: var(--s2a-spacing-2xs);\n  padding: 0 var(--s2a-spacing-sm) 0 var(--s2a-spacing-md);\n  column-gap: 10px;\n}\n\n.feds-brand-image svg {\n  width: 100%;\n  display: block;\n}\n\n/* =========================================\n   Brand Image (Mobile / Desktop variants)\n   ========================================= */\n\n.feds-brand-image svg {\n  color: var(--s2a-color-gray-25);\n}\n\n.feds-brand-image.desktop-brand {\n  display: none;\n}\n\n.feds-brand-image.mobile-brand {\n  display: inherit;\n}\n\n.feds-brand-image.mobile-brand svg {\n  height: var(--s2a-spacing-md);\n  width: 18px; /* no token for 18px */\n}\n\n.feds-brand-image.desktop-brand svg {\n  width: 67px;\n}\n\n/* For light background */\n.feds-brand-image {\n  & img:nth-child(1) { display: inherit; }\n  & img:nth-child(2) { display: none; }\n}\n\n/* For dark background */\n.feds-dark-bg {\n  & .feds-brand-image {\n    & img:nth-child(1) { display: none; }\n    & img:nth-child(2) { display: inherit; }\n  }\n}\n\n/* same behavior for both \"scrolled\" and \"popup open\" states (considering for transparent-white/light background only)*/\n:is(.feds-header-scrolled, .global-navigation:has(.feds-popup:popover-open)) {\n  & .feds-brand-wrapper .feds-brand-image {\n    & img:nth-child(1) { display: inherit; }\n    & img:nth-child(2) { display: none; }\n  }\n}\n\n/* =========================================\n   Animations\n   ========================================= */\n\n@media (max-width: 1023px) {\n  @keyframes brand-fade {\n    from {\n      opacity: 1;\n      visibility: visible;\n    }\n    to {\n      opacity: 0;\n      visibility: hidden;\n    }\n  }\n  header.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-brand,\n  header.global-navigation:has(.feds-menu-active) .feds-brand {\n    animation: brand-fade 0.3s;\n    opacity: 0;\n    pointer-events: none;\n    visibility: hidden;\n  }\n  header.global-navigation .feds-nav-toggle {\n    transform: translateX(0);\n    transition: transform 0.3s ease;\n  }\n  header.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-nav-toggle {\n    transform: translateX(-30px);\n  }\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  li.feds-brand-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    padding-left: 0;\n  }\n\n  .feds-brand-image.desktop-brand {\n    display: inherit;\n  }\n\n  header:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-brand-image svg {\n    color: var(--s2a-color-gray-1000);\n  }\n\n  .feds-brand-image.mobile-brand {\n    display: none;\n  }\n}\n\n/* Mega Menu grid structure for links-card and promo-card */\n\n/* =========================================\n   Gnav Cards Grid (base)\n   ========================================= */\n\n.feds-gnav-cards > li:has(> :nth-child(2)) {\n  display: flex;\n  flex-direction: column;\n  gap: var(--s2a-spacing-2xs);\n}\n\n/* =========================================\n   Product Link in mobile on product list\n   ========================================= */\n\n.feds-popup-header .product-links .feds-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--s2a-color-content-default);\n  text-decoration: none;\n  font-size: var(--s2a-font-size-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: 18px;\n  white-space: nowrap;\n  padding: 0;\n  font-family: var(--feds-font-family);\n}\n\n.feds-popup-header .product-links .feds-link svg {\n  width: 5px;\n  height: 8px;\n  flex-shrink: 0;\n}\n\nul.tabs .product-links {\n  display: none;\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  /* Responsive: fit all columns within width (no promo-card) */\n  .feds-gnav-cards:not(:has(.promo-card)) > li:has(> :nth-child(2)) {\n    gap: var(--s2a-spacing-xs);\n    flex: 2 1 0;\n    flex-direction: row;\n  }\n\n  .feds-gnav-cards:not(:has(.promo-card)) > li:has(> :nth-child(2)) article {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  /* Legacy: fixed widths when promo-card is present */\n  .feds-gnav-cards:has(.promo-card) > li:has(> :nth-child(2)) {\n    gap: var(--s2a-spacing-xs);\n  }\n\n  .feds-gnav-cards:has(.promo-card) > li:has(.promo-card, .links-card) {\n    width: calc(33.33% - 5.33px);\n  }\n\n  .feds-popup .feds-gnav-cards:has(.promo-card, .links-card) {\n    align-items: stretch;\n  }\n\n  .feds-popup .feds-gnav-cards:has(.promo-card, .links-card) article {\n    height: 100%;\n  }\n\n  .feds-popup-header .product-links {\n    display: none;\n  }\n\n  ul.tabs .product-links {\n    display: block;\n  }\n\n  ul.tabs .product-links .feds-link {\n    font-family: var(--feds-font-family);\n    padding: var(--s2a-spacing-md) var(--s2a-spacing-lg);\n  }\n}\n\n/* =========================================\n   Large Desktop (min-width: 1280px) — promo-card layout only\n   ========================================= */\n\n@media (min-width: 1280px) {\n  .feds-gnav-cards:has(.promo-card) > li:has(.promo-card, .links-card) {\n    width: calc(25% - 6px);\n  }\n\n  .feds-gnav-cards:has(.promo-card) > li:has(.promo-card) {\n    width: calc(50% - 4px);\n  }\n\n  .feds-gnav-cards:has(.promo-card) > li:has(> :nth-child(2)) {\n    width: calc(50% - 4px);\n    flex-direction: row;\n  }\n\n  .feds-gnav-cards:has(.promo-card) > li:has(> :nth-child(2)) article {\n    width: calc(50% - 4px);\n  }\n}\n\n/* =========================================\n   Gnav Cards Container\n   ========================================= */\n\n.feds-popup .feds-gnav-cards {\n  list-style: none;\n  margin: 0;\n  padding: var(--s2a-spacing-lg);\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--s2a-spacing-2xs);\n  align-items: stretch;\n}\n\n.feds-popup .feds-gnav-cards > li {\n  min-width: 0;\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  .feds-popup .feds-gnav-cards {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: var(--s2a-spacing-xs);\n    overflow-x: auto;\n    width: 100%;\n    padding-top: 0;\n  }\n\n  .feds-popup .feds-gnav-cards > li {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .feds-popup .feds-gnav-cards:has(.promo-card) > li {\n    flex: 0 0 auto;\n  }\n}\n\n/* =========================================\n   Promo Card\n   ========================================= */\n\n.feds-gnav-cards .promo-card {\n  position: relative;\n  height: 199px;\n}\n\n.feds-gnav-cards .promo-card__bg {\n  height: 100%;\n  width: 100%;\n  display: block;\n  position: absolute;\n}\n\n.feds-gnav-cards .promo-card__bg-image {\n  border-radius: var(--s2a-border-radius-24);\n  display: block;\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.feds-gnav-cards .promo-card__content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n}\n\n.feds-gnav-cards .promo-card__icon {\n  position: absolute;\n  top: var(--s2a-spacing-md);\n  left: var(--s2a-spacing-md);\n  width: var(--s2a-spacing-lg);\n  height: var(--s2a-spacing-lg);\n}\n\n.feds-gnav-cards .promo-card__text-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: block;\n  padding: var(--s2a-spacing-md);\n}\n\n.feds-gnav-cards .promo-card__price,\n.feds-gnav-cards .promo-card__title {\n  margin: 0;\n  color: var(--s2a-color-gray-25);\n}\n\n.feds-gnav-cards .promo-card__price {\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  font-size: var(--s2a-font-size-md);\n  line-height: var(--s2a-font-line-height-24);\n  /* No token for percentage */\n  letter-spacing: -1%;\n}\n\n.feds-gnav-cards .promo-card__title {\n  font-weight: var(--s2a-font-weight-adobe-clean-black);\n  font-size: var(--s2a-typography-font-size-title-4);\n  line-height: var(--s2a-typography-line-height-title-4-temp);\n  letter-spacing: var(--s2a-typography-letter-spacing-title-4);\n  font-family: var(--feds-heading-font-family);\n}\n\n/* =========================================\n   Promo Card CTA\n   ========================================= */\n\n.feds-gnav-cards .promo-card__cta {\n  display: block;\n  margin-top: var(--s2a-spacing-lg);\n}\n\n.feds-gnav-cards .promo-card__cta .feds-secondary-cta {\n  letter-spacing: 0;\n  border: none;\n  background: var(--s2a-color-gray-25);\n  color: var(--s2a-color-gray-1000);\n  padding: 11px var(--s2a-spacing-lg) var(--s2a-spacing-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  font-size: var(--s2a-typography-font-size-label);\n  line-height: var(--s2a-typography-line-height-label);\n  letter-spacing: var(--s2a-typography-letter-spacing-label);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.feds-gnav-cards .promo-card__cta .feds-secondary-cta:hover,\n.feds-gnav-cards .promo-card__cta .feds-secondary-cta:focus {\n  background: var(--s2a-color-gray-1000);\n  color: var(--s2a-color-gray-25);\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  .feds-gnav-cards .promo-card {\n    height: 100%;\n    min-height: 420px;\n  }\n\n  .feds-gnav-cards .promo-card__bg-image {\n    border-radius: var(--s2a-border-radius-md);\n  }\n\n  .feds-gnav-cards .promo-card__cta {\n    margin-top: var(--s2a-spacing-md);\n  }\n}\n\n/* =========================================\n   Responsive: Large Desktop (min-width: 1280px)\n   ========================================= */\n\n@media (min-width: 1280px) {\n  .feds-gnav-cards .promo-card {\n    min-height: auto;\n  }\n\n  .feds-gnav-cards .promo-card__bg-image {\n    border-radius: var(--s2a-border-radius-12);\n  }\n\n  .feds-gnav-cards .promo-card__icon {\n    position: absolute;\n    top: var(--s2a-spacing-lg);\n    left: var(--s2a-spacing-lg);\n  }\n\n  .feds-gnav-cards .promo-card__text-content {\n    width: 100%;\n    box-sizing: border-box;\n    padding: var(--s2a-spacing-lg);\n  }\n\n  .feds-gnav-cards .promo-card__cta {\n    position: absolute;\n    bottom: var(--s2a-spacing-lg);\n    right: var(--s2a-spacing-lg);\n    margin-top: 0;\n  }\n}\n\n/* =========================================\n   Links Card\n   ========================================= */\n\n.feds-popup .links-card {\n  border-radius: var(--s2a-border-radius-24); /* Don't have a token */\n  background: var(--s2a-color-gray-25);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: var(--s2a-spacing-xl) var(--s2a-spacing-lg);\n}\n\n.feds-popup .links-card .links-card-title {\n  margin: 0 0 var(--s2a-spacing-sm);\n  font-size: var(--s2a-typography-font-size-title-4);\n  line-height: var(--s2a-typography-line-height-title-4-temp);\n  letter-spacing: var(--s2a-typography-letter-spacing-title-4);\n  font-weight: var(--s2a-font-weight-adobe-clean-black);\n  color: var(--s2a-color-gray-1000);\n  font-family: var(--feds-heading-font-family);\n}\n\n\n\n/* =========================================\n   Links Card List\n   ========================================= */\n\n.feds-popup .links-card .links-card-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  line-height: 120%;\n}\n\n.feds-popup .links-card .links-card-links li {\n  display: flex;\n  padding: var(--s2a-spacing-xs) 0;\n}\n\n.feds-popup .links-card .links-card-links .feds-link {\n  padding: 0;\n  color: var(--s2a-color-gray-1000);\n  font-size: var(--s2a-font-size-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-regular);\n  display: inline-flex;\n}\n\n/* =========================================\n   Links Card Footer\n   ========================================= */\n\n.feds-popup .links-card .links-card-footer {\n  width: 100%;\n  margin-top: var(--s2a-spacing-lg);\n}\n\n.feds-popup .links-card .links-card-footer .feds-secondary-cta {\n  width: 100%;\n  box-sizing: border-box;\n  justify-content: center;\n  background-color: transparent;\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  .feds-popup .links-card {\n    border-radius: var(--s2a-border-radius-16); /* Don't have a token */\n    padding: var(--s2a-spacing-lg) var(--s2a-spacing-lg) var(--s2a-spacing-md);\n  }\n\n  .feds-popup .links-card .links-card-footer .feds-secondary-cta {\n    color: var(--s2a-color-gray-1000);\n    background-color: transparent;\n  }\n  .feds-popup .links-card .links-card-footer .feds-secondary-cta:hover {\n    color: var(--s2a-color-gray-25);\n    background-color:var(--s2a-color-gray-1000);\n  }\n}\n\n/* =========================================\n   Responsive: Large Desktop (min-width: 1280px)\n   ========================================= */\n\n@media (min-width: 1280px) {\n  .feds-popup .links-card {\n    padding-bottom: var(--s2a-spacing-lg);\n  }\n} \n\n/* =========================================\n   Product List Container\n   ========================================= */\n\n.feds-popup .product-list {\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: start;\n  gap: var(--s2a-spacing-lg);\n  padding: var(--s2a-spacing-lg);\n  border-radius: var(--s2a-border-radius-md);\n  width: 100%;\n}\n\n.product-list .tabs,\n.product-list .tab-content,\n.product-list .product-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* =========================================\n   Tabs\n   ========================================= */\n\n.product-list .tabs {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 4px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  background-color: transparent;\n}\n\n.feds-popup .product-list .tabs {\n  margin-left: calc(0px - var(--s2a-spacing-lg));\n  margin-right: calc(0px - var(--s2a-spacing-lg));\n  padding: 0 var(--s2a-spacing-lg);\n}\n\n.product-list .tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.product-list .tabs li {\n  list-style: none;\n  flex: 0 0 auto;\n}\n\n.product-list .tabs button.tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: max-content;\n  white-space: nowrap;\n  min-height: 40px;\n  border: 0;\n  /* No token: 75px radius */\n  border-radius: 75px;\n  padding: var(--s2a-spacing-md) var(--s2a-spacing-lg);\n  text-align: center;\n  font-family: var(--feds-font-family);\n  font-size: var(--s2a-font-size-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: 8px;\n  color: var(--s2a-color-content-default);\n  background: rgb(0 0 0 / 4%);\n  cursor: pointer;\n}\n\n.product-list .tabs button.tab[aria-selected=\"true\"] {\n  background: var(--s2a-color-gray-1000);\n  color: var(--s2a-color-gray-25);\n}\n\n.product-list .tabs button.tab:hover:not([aria-selected=\"true\"]) {\n  color: var(--s2a-color-gray-25);\n  background-color: var(--s2a-color-content-subtle);\n}\n\n/* =========================================\n   Tab Content / Tabpanels\n   ========================================= */\n\n.product-list .tab-content > li {\n  list-style: none;\n}\n\n.product-list .tab-content [role=\"tabpanel\"][hidden] {\n  display: none;\n}\n\n.product-list .tab-content [role=\"tabpanel\"] {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--s2a-spacing-2xs);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.product-list .tab-content [role=\"tabpanel\"] li {\n  display: flex;\n}\n\n.product-list .tab-content [role=\"tabpanel\"] .feds-product-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 120px;\n  flex: 1;\n  background-color: var(--s2a-color-gray-25);\n  justify-content: space-between;\n  outline-offset: -1px;\n}\n\n.feds-popup .product-list .tab-content [role=\"tabpanel\"] .feds-product-card:hover {\n  background: var(--s2a-color-gray-1000);\n}\n\n.feds-popup .product-list .tab-content [role=\"tabpanel\"] .feds-product-card:hover .feds-product-card__title {\n  color: var(--s2a-color-gray-25);\n}\n\n/* =========================================\n   Product Links\n   ========================================= */\n\n.product-list .product-links a {\n  color: var(--s2a-color-content-default);\n}\n\n.product-list .product-links .feds-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.product-list .product-links .feds-link svg {\n  width: 3px;\n  height: 6px;\n  flex-shrink: 0;\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  .feds-popup .product-list {\n    grid-template-columns: 1fr minmax(0, 3fr);\n    gap: var(--s2a-spacing-xs);\n    padding: 0 var(--s2a-spacing-lg) var(--s2a-spacing-lg);\n  }\n\n  .product-list .tabs {\n    display: block;\n    overflow: visible;\n  }\n\n  .feds-popup .product-list .tabs {\n    margin: 0;\n    padding: 0;\n  }\n\n  .product-list .tabs li {\n    flex: unset;\n  }\n\n  .product-list .tabs button.tab {\n    width: auto;\n    min-height: 44px;\n    margin-bottom: var(--s2a-spacing-2xs);\n  }\n\n  .product-list .tab-content [role=\"tabpanel\"] {\n    grid-template-columns: repeat(3, 1fr);\n    gap: var(--s2a-spacing-xs);\n  }\n}\n\n/* =========================================\n   Responsive: Very Large Desktop (min-width: 1920px)\n   ========================================= */\n\n@media (min-width: 1920px) {\n  .feds-popup .product-list {\n    grid-template-columns: auto minmax(0,3fr);\n  }\n  .feds-popup .product-list .tab-content [role=\"tabpanel\"] {\n    grid-template-columns: repeat(5, 1fr);\n  }\n  .feds-popup .product-list .tabs {\n    margin-right: var(--s2a-spacing-4xl);\n  }\n}\n\n.product-hint {\n  display: none;\n}\n\n/* =========================================\n   Panels Container\n   ========================================= */\n\n.global-navigation .panels {\n  list-style: none;\n  margin: 0 auto;\n  padding: 36px clamp(var(--s2a-spacing-lg), 4vw, 56px) var(--s2a-spacing-40);\n  gap: var(--s2a-spacing-xl);\n  width: min(1200px, 100%);\n  box-sizing: border-box;\n  color: var(--s2a-color-gray-1000);\n  width: 100%;\n}\n\n.panels > li {\n  min-width: 0;\n  /* No token: design #f6f6f6; using gray-75 */\n  background-color: var(--s2a-color-gray-75);\n  border-radius: var(--s2a-border-radius-md);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.feds-popup .panels .feds-secondary-cta {\n  margin-top: auto;\n  margin-bottom: var(--s2a-spacing-sm);\n  align-self: center;\n  width: 75%;\n}\n\n.panels h4 {\n  font-family: var(--feds-heading-font-family);\n  font-size: var(--s2a-font-size-2xl);\n  line-height: var(--s2a-font-line-height-20);\n  margin-left: var(--s2a-spacing-lg);\n}\n\n/* =========================================\n   Link Panel\n   ========================================= */\n\n.global-navigation.site-pivot .panels .link-panel {\n  list-style: none;\n  margin: 0 0 0 var(--s2a-spacing-lg);\n  padding: 0;\n}\n\n.global-navigation.site-pivot .panels .link-panel + .feds-link {\n  color: var(--s2a-color-gray-1000);\n  margin-left: var(--s2a-spacing-lg);\n  padding-left: 0;\n  margin-top: auto;\n}\n\n.global-navigation.site-pivot .panels .link-panel + .feds-link::after {\n  content: \"\";\n  width: var(--s2a-spacing-2xs);\n  height: var(--s2a-spacing-2xs);\n  border-right: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);\n  border-top: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);\n  transform: translateY(8%) translateX(var(--s2a-spacing-xs)) rotate(45deg);\n}\n\n.panels .link-panel .feds-link,\n.panels .panel-footer-link .feds-link {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  padding: var(--s2a-spacing-sm) 0;\n  text-decoration: none;\n  font-size: var(--s2a-font-size-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: 1.35;\n  color: var(--s2a-color-gray-1000);\n}\n\n.panels .link-panel-container > .feds-secondary-cta,\n.panels > li > .feds-secondary-cta {\n  margin-top: var(--s2a-spacing-sm);\n}\n\n/* =========================================\n   List Image Panel\n   ========================================= */\n\n.panels > li:has(> .list-image-panel) {\n  background-color: var(--s2a-color-gray-1000);\n  border: var(--s2a-border-width-lg) var(--s2a-color-gray-1000) solid;\n}\n\n.list-image-panel {\n  display: flex;\n  background-color: transparent;\n  color: var(--s2a-color-gray-25);\n  height: 100%;\n  align-items: stretch;\n  gap: var(--s2a-spacing-sm);\n}\n\n.list-image-panel .link-panel-container {\n  display: flex;\n  flex-direction: column;\n  min-width: 250px;\n}\n\n.panels .list-image-panel .feds-link {\n  color: var(--s2a-color-gray-25);\n}\n\n.panels .list-image-panel .feds-secondary-cta {\n  color: var(--s2a-color-gray-25);\n  margin: auto 0 var(--s2a-spacing-sm) 0;\n  width: calc(100% - var(--s2a-spacing-lg));\n}\n\n.panels .list-image-panel .feds-secondary-cta:hover {\n  color: var(--s2a-color-gray-1000);\n}\n\n.panels .list-image-panel li {\n  border-radius: var(--s2a-border-radius-sm);\n  padding: var(--s2a-spacing-sm);\n}\n\n.panels .list-image-panel li a.feds-link {\n  padding: 0;\n}\n\n.panels .list-image-panel li:hover {\n  background-color: var(--s2a-color-gray-25);\n  position: relative;\n}\n\n.panels .list-image-panel li:hover .feds-link {\n  color: var(--s2a-color-gray-1000);\n}\n\n.panels .list-image-panel li:hover .feds-link::after {\n  content: \"\";\n  position: absolute;\n  right: var(--s2a-spacing-sm);\n  width: var(--s2a-spacing-2xs);\n  height: var(--s2a-spacing-2xs);\n  border-right: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);\n  border-top: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);\n  transform: translateY(8%) translateX(100%) rotate(45deg);\n}\n\n.list-image-panel picture {\n  display: block;\n}\n\n.list-image-panel picture img {\n  display: block;\n  height: 100%;\n  max-height: 100%;\n  width: auto;\n  /* No token: 14px radius */\n  border-radius: 14px;\n  object-fit: cover;\n}\n\n/* =========================================\n   Image Panel\n   ========================================= */\n\n.image-panel {\n  position: relative;\n  border-radius: var(--s2a-border-radius-md);\n  overflow: hidden;\n  min-height: 320px;\n  isolation: isolate;\n  display: grid;\n}\n\n.image-panel > picture {\n  display: block;\n  height: 100%;\n  grid-area: 1 / 1;\n}\n\n.image-panel > picture img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.image-panel .overlay {\n  grid-area: 1 / 1;\n  display: grid;\n  gap: var(--s2a-spacing-sm);\n  padding: 18px 18px 20px;\n  color: var(--s2a-color-gray-25);\n  /* Unsure: 80% vs 64% token */\n  background: linear-gradient(\n    180deg,\n    rgb(0 0 0 / 0%) 0%,\n    var(--s2a-color-transparent-black-64) 70%\n  );\n  grid-template-columns: 300px auto auto;\n  grid-template-rows: var(--s2a-spacing-3xl) auto 50px;\n}\n\n.image-panel .icon {\n  width: 34px;\n  height: 34px;\n  grid: 1 / 1 / 1 / 1;\n}\n\n.image-panel .icon img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.image-panel .text {\n  display: grid;\n  gap: 3px;\n  grid-area: 3 / 1 / 3 / 1;\n}\n\n.image-panel .text span:first-child {\n  font-size: var(--s2a-font-size-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  line-height: 1.2;\n}\n\n.image-panel .text span:last-child {\n  font-family: var(--feds-heading-font-family);\n  font-size: 21px;\n  font-weight: var(--s2a-font-weight-adobe-clean-extrabold);\n  line-height: 1.2;\n}\n\n.image-panel-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  min-height: 34px;\n  padding: 0 14px;\n  border-radius: var(--s2a-border-radius-round);\n  color: var(--s2a-color-gray-1000);\n  text-decoration: none;\n  font-size: var(--s2a-font-size-sm);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  background-color: var(--s2a-color-gray-25);\n  backdrop-filter: blur(1px);\n  grid-area: 3 / 3 / 3 / 3;\n  justify-self: end;\n}\n\n/* =========================================\n   Responsive: Mobile (max-width: 1023px)\n   ========================================= */\n\n@media (max-width: 1023px) {\n  .panels {\n    display: block !important;\n    grid-template-columns: none !important;\n    grid-template-rows: none !important;\n    padding: 22px var(--s2a-spacing-md) 28px;\n  }\n\n  .panels > li + li {\n    margin-top: 22px;\n  }\n\n  .list-image-panel {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"header\"\n      \"image\"\n      \"list\";\n    row-gap: 14px;\n  }\n}\n\n/* =========================================\n   Featured Card\n   ========================================= */\n\n.feds-popup .featured-card {\n  border-radius: 24px;\n  background: var(--s2a-color-gray-25);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: var(--s2a-spacing-lg);\n  justify-content: space-between;\n  align-items: flex-start;\n  overflow: hidden;\n  height: 100%;\n}\n\n.feds-popup .featured-card .featured-eyebrow {\n  /* No token: design uses custom gray; using content-subtle */\n  color: var(--s2a-color-content-body-subtle);\n  font-family: var(--body-font-family);\n  font-size: var(--s2a-typography-font-size-label);\n  font-weight: var(--s2a-font-weight-adobe-clean-bold);\n  letter-spacing: var(--s2a-typography-letter-spacing-label);\n  line-height: var(--s2a-typography-line-height-label);\n}\n\n.feds-popup .featured-card h2 {\n  margin: 0;\n  font-family: var(--feds-heading-font-family);\n  font-size: var(--s2a-typography-font-size-title-4);\n  line-height: var(--s2a-typography-line-height-title-4-temp);\n  letter-spacing: var(--s2a-typography-letter-spacing-title-4);\n  color: var(--s2a-color-content-default);\n  padding: var(--s2a-spacing-md) 0 var(--s2a-spacing-xs) 0;\n  font-weight: var(--s2a-font-weight-adobe-clean-black);\n}\n\n.featured-card .featured-subtitle {\n  font-size: var(--s2a-font-size-sm);\n  line-height: 120%;\n  color: var(--s2a-color-content-subtle);\n}\n\n.featured-card .feds-link {\n  padding: var(--s2a-spacing-md) 0;\n  color: var(--s2a-color-gray-1000);\n  display: inline-flex;\n  gap: 6px;\n}\n\n.featured-card span {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 6px;\n}\n\n.featured-card span svg {\n  margin-top: 2px;\n  color: var(--s2a-color-gray-1000);\n  width: 3px;\n  height: 8px;\n}\n\n.featured-card a.feds-secondary-cta {\n  background: var(--s2a-color-gray-1000);\n  color: var(--s2a-color-gray-25);\n}\n\n/* =========================================\n   Featured Card Footer\n   ========================================= */\n\n.featured-card .footer-container {\n  width: 100%;\n}\n\n.featured-card .footer-container a {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.featured-card .footer-container a.feds-secondary-cta:hover {\n  background: var(--s2a-color-gray-1000);\n}\n\n/* =========================================\n   Responsive: Desktop (min-width: 1024px)\n   ========================================= */\n\n@media (min-width: 1024px) {\n  .feds-popup .featured-card {\n    border-radius: 12px;\n  }\n\n  .featured-card a.feds-secondary-cta {\n    background: transparent;\n    color: var(--s2a-color-gray-1000);\n    border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);\n  }\n\n  .feds-popup .feds-gnav-cards:has(.featured-card) {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    flex-wrap: unset;\n    overflow-x: unset;\n  }\n}\n\n/* =========================================\n   Responsive: Large Desktop (min-width: 1280px)\n   ========================================= */\n\n@media (min-width: 1280px) {\n  .feds-popup .feds-gnav-cards:has(.featured-card) {\n    grid-template-columns: repeat(5, 1fr);\n  }\n\n  .feds-popup .featured-card {\n    min-height: 307px;\n  }\n}\n\n/* =========================================\n   Hover: Desktop with pointer device only\n   ========================================= */\n\n@media (min-width: 1024px) and (hover: hover) {\n  .featured-card a.feds-secondary-cta {\n    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  }\n\n  .featured-card a.feds-secondary-cta:hover {\n    background: var(--s2a-color-gray-1000);\n    color: var(--s2a-color-gray-25);\n    border-color: var(--s2a-color-gray-25);\n  }\n}\n";
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(String.raw`/**
 * Generated by scripts/build-css.js - do not edit.
 * Pruned design tokens (used by gnav) + global navigation CSS.
 */

:root {
  --s2a-color-gray-25: #fff;
  --s2a-color-gray-50: #f8f8f8;
  --s2a-color-gray-75: #f3f3f3;
  --s2a-color-gray-300: #dadada;
  --s2a-color-gray-400: #c6c6c6;
  --s2a-color-gray-700: #505050;
  --s2a-color-gray-800: #292929;
  --s2a-color-gray-900: #131313;
  --s2a-color-gray-1000: #000;
  --s2a-color-blue-100: #f5f9ff;
  --s2a-color-blue-200: #e5f0fe;
  --s2a-color-blue-800: #4b75ff;
  --s2a-color-blue-900: #3b63fb;
  --s2a-color-red-900: #d73220;
  --s2a-color-transparent-black-64: rgb(0 0 0 / 64%);
  --s2a-color-brand-adobe-red: #eb1000;
  --s2a-border-radius-0: 0;
  --s2a-border-radius-2: 2px;
  --s2a-border-radius-4: 4px;
  --s2a-border-radius-8: 8px;
  --s2a-border-radius-12: 12px;
  --s2a-border-radius-16: 16px;
  --s2a-border-radius-24: 24px;
  --s2a-border-radius-32: 32px;
  --s2a-border-radius-999: 999px;
  --s2a-border-width-1: 1px;
  --s2a-border-width-2: 2px;
  --s2a-border-width-4: 4px;
  --s2a-opacity-32: 32px;
  --s2a-opacity-48: 48px;
  --s2a-opacity-64: 64px;
  --s2a-spacing-0: 0;
  --s2a-spacing-2: 2px;
  --s2a-spacing-4: 4px;
  --s2a-spacing-8: 8px;
  --s2a-spacing-12: 12px;
  --s2a-spacing-16: 16px;
  --s2a-spacing-20: 20px;
  --s2a-spacing-24: 24px;
  --s2a-spacing-32: 32px;
  --s2a-spacing-40: 40px;
  --s2a-spacing-48: 48px;
  --s2a-spacing-64: 64px;
  --s2a-spacing-80: 80px;
  --s2a-spacing-96: 96px;
  --s2a-spacing-124: 124px;
  --s2a-spacing-160: 160px;
  --s2a-spacing-240: 240px;
  --s2a-font-family-adobe-clean: "Adobe Clean";
  --s2a-font-family-adobe-clean-display: "Adobe Clean Display";
  --s2a-font-letter-spacing-0: 0;
  --s2a-font-letter-spacing-neg-3_84: -3.84px;
  --s2a-font-letter-spacing-neg-3_2: -3.2px;
  --s2a-font-letter-spacing-neg-2_88: -2.88px;
  --s2a-font-letter-spacing-neg-1_68: -1.68px;
  --s2a-font-letter-spacing-neg-1_44: -1.44px;
  --s2a-font-letter-spacing-neg-1_2: -1.2px;
  --s2a-font-letter-spacing-neg-0_96: -0.96px;
  --s2a-font-letter-spacing-neg-0_48: -0.48px;
  --s2a-font-letter-spacing-neg-0_2: -0.2px;
  --s2a-font-letter-spacing-0_16: 0.16px;
  --s2a-font-letter-spacing-0_24: 0.24px;
  --s2a-font-line-height-16: 1.333;
  --s2a-font-line-height-18: 1.286;
  --s2a-font-line-height-20: 1.25;
  --s2a-font-line-height-24: 1.2;
  --s2a-font-line-height-32: 1.143;
  --s2a-font-line-height-40: 1.111;
  --s2a-font-line-height-48: 1.2;
  --s2a-font-line-height-56: 1.167;
  --s2a-font-line-height-69: 1.232;
  --s2a-font-line-height-76: 1.188;
  --s2a-font-line-height-92: 1.278;
  --s2a-font-size-12: 0.75rem;
  --s2a-font-size-14: 0.875rem;
  --s2a-font-size-16: 1rem;
  --s2a-font-size-18: 1.125rem;
  --s2a-font-size-20: 1.25rem;
  --s2a-font-size-24: 1.5rem;
  --s2a-font-size-32: 2rem;
  --s2a-font-size-40: 2.5rem;
  --s2a-font-size-48: 3rem;
  --s2a-font-size-56: 3.5rem;
  --s2a-font-size-64: 4rem;
  --s2a-font-size-72: 4.5rem;
  --s2a-font-size-80: 5rem;
  --s2a-font-size-96: 6rem;
  --s2a-font-weight-adobe-clean-black: 900;
  --s2a-font-weight-adobe-clean-extrabold: 800;
  --s2a-font-weight-adobe-clean-bold: 700;
  --s2a-font-weight-adobe-clean-regular: 400;
  --s2a-blur-8: 8px;
  --s2a-blur-16: 16px;
  --s2a-blur-32: 32px;
  --s2a-blur-64: 64px;
  --color-transparent-black-12: rgb(0 0 0 / 12%);
  --color-transparent-black-16: rgb(0 0 0 / 16%);
}

:root {
  --s2a-border-radius-sm: var(--s2a-border-radius-8);
  --s2a-border-radius-md: var(--s2a-border-radius-16);
  --s2a-border-radius-round: var(--s2a-border-radius-999);
  --s2a-border-width-sm: var(--s2a-border-width-1);
  --s2a-border-width-md: var(--s2a-border-width-2);
  --s2a-border-width-lg: var(--s2a-border-width-4);
  --s2a-spacing-2xs: var(--s2a-spacing-4);
  --s2a-spacing-xs: var(--s2a-spacing-8);
  --s2a-spacing-sm: var(--s2a-spacing-12);
  --s2a-spacing-md: var(--s2a-spacing-16);
  --s2a-spacing-lg: var(--s2a-spacing-24);
  --s2a-spacing-xl: var(--s2a-spacing-32);
  --s2a-spacing-2xl: var(--s2a-spacing-40);
  --s2a-spacing-3xl: var(--s2a-spacing-48);
  --s2a-spacing-4xl: var(--s2a-spacing-64);
  --s2a-font-family-heading: var(--s2a-font-family-adobe-clean-display);
  --s2a-font-size-xs: var(--s2a-font-size-12);
  --s2a-font-size-sm: var(--s2a-font-size-14);
  --s2a-font-size-md: var(--s2a-font-size-16);
  --s2a-font-size-xl: var(--s2a-font-size-20);
  --s2a-font-size-2xl: var(--s2a-font-size-24);
  --s2a-blur-sm: var(--s2a-blur-16);
}

:root[data-theme="light"] {
  --s2a-color-content-default: var(--s2a-color-gray-800);
  --s2a-color-content-subtle: var(--s2a-color-gray-700);
  --s2a-color-content-body-subtle: var(--s2a-color-transparent-black-64);
}

/* ========== Gnav component styles ========== */

/**
 * Global Navigation Styles
 * Styles for the federal global navigation component
 */

/* =========================================
   Skip to Main Content Link
   ========================================= */

.feds-skip-link {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.trap-focus-gnav {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  display: none;
}

nav:has(.feds-menu-active) .trap-focus-gnav {
  display: block;
}

.feds-skip-link:focus {
  outline: 2px solid var(--s2a-color-blue-800);
  outline-offset: 1px;
}

/* =========================================
   Header Shell
   ========================================= */
:root {
  --feds-font-family: var(--s2a-font-family-adobe-clean), adobe-clean, "Trebuchet MS", sans-serif;
  --feds-heading-font-family: "Adobe Clean Display Black", var(--s2a-font-family-heading), adobe-clean-display, "Arial Bold Adjusted", sans-serif;
  --s2a-typography-line-height-title-4-temp: 1;
}


header.global-navigation {
  width: 100%;
  background: transparent;
  visibility: visible;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  /* right: 0;
  max-width: var(--grid-max-width-default);
  margin: auto; */
}

header.feds-header-scrolled .feds-link {
  color: var(--s2a-color-gray-1000);
}

header.feds-header-scrolled nav {
  color: var(--s2a-color-gray-1000);
  box-shadow: 0 67px 19px 0 rgba(0, 0, 0, 0.00), 0 43px 17px 0 rgba(0, 0, 0, 0.01), 0 24px 14px 0 rgba(0, 0, 0, 0.04), 0 11px 11px 0 rgba(0, 0, 0, 0.07), 0 3px 6px 0 rgba(0, 0, 0, 0.08);
}

.global-navigation.site-pivot .universal-nav-container .profile-signed-out button {
  color: var(--s2a-color-gray-1000);
  border: 1px solid var(--s2a-color-gray-25);
  background-color: var(--s2a-color-gray-25);
}

.global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .universal-nav-container .profile-signed-out button {
  color: inherit;
  border-color: var(--s2a-color-gray-1000);
  background-color: transparent;
}

.global-navigation.site-pivot.feds-header-scrolled .universal-nav-container .profile-signed-out button:hover,
.global-navigation.site-pivot.feds-header-scrolled .universal-nav-container .profile-signed-out button:focus-visible {
  color: inherit;
  background-color: var(--s2a-color-gray-25);
}

.global-navigation.site-pivot .universal-nav-container #universal-nav {
  justify-content: flex-end;
}

.global-navigation.site-pivot .feds-utilities {
  margin-left: auto;
  padding-right: var(--s2a-spacing-md);
}

::backdrop {
  opacity: 1;
}

.global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link {
  cursor: pointer;
}

/* =========================================
   Navigation Bar
   ========================================= */

.global-navigation.site-pivot nav {
  display: flex;
  align-items: center;
  height: var(--s2a-spacing-64);
  width: calc(100% - 2 * var(--s2a-spacing-xs));
  justify-content: flex-start;
}

header.global-navigation nav {
  position: fixed;
  inset:
    var(--s2a-spacing-xs)
    var(--s2a-spacing-xs)
    0
    var(--s2a-spacing-xs);
  width: calc(100% - var(--s2a-spacing-xs) * 2);
  max-width: calc(1920px - var(--s2a-spacing-xs) * 2);
  margin: 0 auto;
  border: none;
  padding: 0;
  overflow: visible;
  border-radius: var(--s2a-border-radius-16);

  background-color: transparent;
}

header.global-navigation nav::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: transparent;
  backdrop-filter: blur(0px);
  border-radius: var(--s2a-border-radius-16);
  z-index: -1;
  transition: all 0.48s cubic-bezier(0.42, 0, 0.2, 1),
              height 0.35s ease;
}

header.global-navigation.feds-header-scrolled nav::after {
  backdrop-filter: blur(var(--s2a-blur-sm));
}

header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {
  width: 100vw;
  border-radius: 0 0 var(--s2a-border-radius-16) var(--s2a-border-radius-16);
  background-color: var(--s2a-color-gray-75);
  left: calc(0px - var(--s2a-spacing-xs));
  top: calc(0px - var(--s2a-spacing-xs) * 2);
  backdrop-filter: blur(0px);
}

@media (max-width: 1023px) {
  header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {
    height: calc(100dvh + var(--s2a-spacing-xs));
  }
}

header.global-navigation.feds-header-scrolled nav::after {
  background-color: rgba(255, 255, 255, 0.51);
}

.global-navigation nav > ul {
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: inherit;
  align-items: center;
  padding-left: 0;
}

.global-navigation nav > ul > li {
  display: flex;
  align-items: center;
}

.global-navigation.site-pivot ul {
  list-style: none;
  margin: 0;
}

/* =========================================
   Nav Links
   ========================================= */

.feds-link {
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  font-family: var(--feds-font-family);
  font-size: var(--s2a-typography-font-size-body-sm);
  line-height: var(--s2a-typography-line-height-body-sm);
  letter-spacing: var(--s2a-typography-letter-spacing-body-sm);
  display: flex;
  align-items: center;
  border: 0;
  background-color: transparent;
  padding: var(--s2a-spacing-sm);
  color: var(--s2a-color-gray-25);
  opacity: 1;
  text-decoration: none;
}

.feds-link:hover {
  text-decoration: underline;
}

.global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link {
  color: var(--s2a-color-gray-1000);
  font-size: var(--s2a-typography-font-size-title-2);
  line-height: var(--s2a-typography-line-height-title-2);
  letter-spacing: var(--s2a-typography-letter-spacing-title-2);
  padding: var(--s2a-spacing-xs) 0;
}

.global-navigation .feds-gnav-items > li > .feds-link:hover {
  text-decoration: none;
  opacity: 1;
  color: var(--s2a-color-gray-25);
}

.global-navigation.feds-header-scrolled .feds-gnav-items > li > .feds-link:hover {
  color: var(--s2a-color-gray-1000);
}



/* =========================================
   Nav Toggle (Hamburger)
   ========================================= */

.global-navigation nav .feds-nav-toggle {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  color: var(--s2a-color-gray-25);
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--s2a-font-size-xl);
  /* No token: font-weight 300 */
  font-weight: 300;
}

.global-navigation nav .feds-nav-toggle svg {
  width: 14px;
  height: 7px;
  flex-shrink: 0;
  color: var(--s2a-color-gray-25);
}

.global-navigation.feds-header-scrolled nav .feds-nav-toggle svg {
  color: var(--s2a-color-gray-1000);
}

/* =========================================
   Utilities (App Switcher, Profile)
   ========================================= */

.global-navigation .unav-comp-app-switcher.unav-comp-icon svg,
.global-navigation .unav-comp-external-notifications svg path,
.global-navigation .unav-comp-cart svg {
  fill: var(--s2a-color-gray-25);
}

.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .unav-comp-app-switcher.unav-comp-icon svg,
.global-navigation .unav-comp-app-switcher.unav-comp-icon.unav-comp-app-switcher-open svg,
.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .unav-comp-cart svg {
  fill: var(--s2a-color-gray-1000);
}

.global-navigation.feds-header-scrolled .unav-comp-app-switcher.unav-comp-icon svg,
.global-navigation.feds-header-scrolled .unav-comp-external-notifications svg path,
.global-navigation.feds-header-scrolled .unav-comp-cart svg {
  fill: var(--s2a-color-gray-1000);
}

.global-navigation .unav-comp-app-switcher.unav-comp-icon:hover svg,
.global-navigation .unav-comp-app-switcher.unav-comp-icon:focus-visible svg,
.global-navigation .unav-comp-external-notifications:hover svg path,
.global-navigation .unav-comp-cart:hover svg,
.global-navigation .unav-comp-cart:focus-visible svg {
  fill: var(--s2a-color-gray-1000);
}

.global-navigation.feds-header-scrolled .universal-nav-container .profile-signed-out button {
  color: var(--s2a-color-gray-1000);
  border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);
  background-color: transparent;
}

header.global-navigation:has(.feds-popup:popover-open) .unav-comp-app-switcher.unav-comp-icon svg,
header.global-navigation:has(.feds-popup:popover-open) .unav-comp-external-notifications svg path,
header.global-navigation:has(.feds-popup:popover-open) .unav-comp-cart svg {
  fill: inherit;
}

header.global-navigation:has(.feds-popup:popover-open) .unav-comp-tooltip {
  display:none !important;
}

/* =========================================
   Popup (Mega Menu Container)
   ========================================= */

.feds-popup {
  position: fixed;
  inset: calc(var(--s2a-spacing-64) + var(--s2a-spacing-8) - 1px) 0 auto 0;
  width: 100%;
  max-width: none;
  max-height: calc(100dvh - var(--s2a-spacing-64));
  margin: 0;
  border: 0;
  padding: 0;
  overflow: auto;
  overscroll-behavior: contain;
  background-color:transparent;
}

.feds-popup:popover-open {
  display: block;
  /* No token for 18px */
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}

.feds-popup > * {
  width: min(1200px, 100%);
  box-sizing: border-box;
}

.feds-popup .feds-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--s2a-spacing-xs) var(--s2a-spacing-lg);
}

.feds-popup .feds-popup-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.feds-popup .feds-popup-back-button {
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--s2a-color-content-default);
  cursor: pointer;
}

.feds-popup .feds-popup-back-button svg {
  width: var(--s2a-spacing-20);
  height: var(--s2a-spacing-20);
}

.feds-popup .feds-popup-back-button .feds-popup-title {
  font-size: var(--s2a-typography-font-size-title-2);
  line-height: var(--s2a-typography-line-height-title-2);
  letter-spacing: var(--s2a-typography-letter-spacing-title-2);
  font-weight: var(--s2a-font-weight-adobe-clean-black);
  font-family: var(--feds-heading-font-family);
  color: var(--s2a-color-content-default);
  margin-left: 10px; /* replace with token if we find one later */
}

/* =========================================
   Link Groups
   ========================================= */

.feds-popup .feds-product-card {
  display: grid;
  grid-template-columns: var(--s2a-spacing-xl) minmax(0, 1fr);
  gap: var(--s2a-spacing-lg);
  min-height: 52px;
  align-items: start;
  border-radius: var(--s2a-border-radius-md);
  padding: var(--s2a-spacing-lg);
  text-decoration: none;
  color: var(--s2a-color-content-default);
}

.feds-popup .feds-product-card:hover .feds-product-card__title,
.feds-popup .feds-product-card:hover .feds-product-card__subtitle {
  color: var(--s2a-color-gray-25);
}

.feds-popup .feds-product-card__icon {
  display: block;
  width: var(--s2a-spacing-lg);
  height: var(--s2a-spacing-lg);
  margin-top: var(--s2a-spacing-2xs);
}

.feds-popup .feds-product-card__icon-img {
  display: block;
  width: 100%;
  height: 100%;
}

.feds-popup .feds-product-card__title {
  font-weight: var(--s2a-font-weight-adobe-clean-black);
  font-size: var(--s2a-typography-font-size-title-4);
  line-height: var(--s2a-typography-line-height-title-4-temp);
  letter-spacing: var(--s2a-typography-letter-spacing-title-4);
  font-family: var(--feds-heading-font-family);
}

.feds-popup .feds-product-card__badges {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-bottom: var(--s2a-spacing-xs);
}

.feds-popup .feds-product-card__badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);
  border-radius: var(--s2a-border-radius-sm);
  font-size: var(--s2a-font-size-xs);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: var(--s2a-typography-line-height-caption);
  color: var(--s2a-color-gray-1000);
  letter-spacing: var(--s2a-typography-letter-spacing-caption);
}

.feds-popup .feds-product-card__badge--filled {
  border-color: var(--s2a-color-gray-1000);
  background: var(--s2a-color-gray-1000);
  color: var(--s2a-color-gray-25);
}

.feds-popup .feds-product-card__subtitle {
  margin-top: var(--s2a-spacing-2xs);
  font-size: var(--s2a-typography-font-size-body-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-regular);
  line-height: var(--s2a-typography-line-height-body-sm);
  letter-spacing: var(--s2a-typography-letter-spacing-body-sm);
  color: var(--s2a-color-content-body-subtle);
}

.feds-popup .feds-product-card__price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: var(--s2a-spacing-sm);
}

.feds-popup .feds-product-card__old-price {
  font-size: var(--s2a-font-size-xs);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: 1;
  text-decoration: line-through;
  /* No token: design uses custom gray */
  color: var(--s2a-color-content-subtle);
}

.feds-popup .feds-product-card__new-price {
  font-size: var(--s2a-font-size-xs);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: 1;
  color: var(--s2a-color-gray-1000);
}

.feds-popup .feds-product-card--blue {
  background: var(--s2a-color-blue-100);
}

.feds-popup .feds-product-card--blue:hover {
  background: var(--s2a-color-blue-200);
}

.feds-popup .feds-product-card:hover .feds-product-card__old-price,
.feds-popup .feds-product-card:hover .feds-product-card__new-price,
.feds-popup .feds-product-card:hover .feds-product-card__badge {
  color: var(--s2a-color-gray-25);
  border-color: var(--s2a-color-gray-25);
}

.feds-popup .feds-product-card:hover .feds-product-card__badge--filled {
  background: var(--s2a-color-gray-25);
  color: var(--s2a-color-gray-1000);
}

.feds-product-card .feds-product-card-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

/* =========================================
   Secondary CTAs
   ========================================= */

.feds-popup .feds-secondary-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 11px 14px 10px;
  border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);
  border-radius: var(--s2a-border-radius-round);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  font-size: var(--s2a-typography-font-size-body-sm);
  line-height: var(--s2a-typography-line-height-body-sm);
  letter-spacing: var(--s2a-typography-letter-spacing-body-sm);
  color: var(--s2a-color-content-default);
  text-decoration: none;
}

.feds-popup .feds-secondary-cta:hover {
  background: var(--s2a-color-gray-75);
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  .global-navigation nav .feds-nav-toggle {
    display: none;
  }

  .global-navigation nav > ul > li.feds-menu-wrapper {
    position: static;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    width: auto;
    height: unset;
    border: 0;
    outline: 0;
    box-shadow: none;
    justify-content: space-between;
    background-color: transparent;
    opacity: 1;
    visibility: visible;
    translate: unset;
    transition: unset;
  }

  .global-navigation.site-pivot nav {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .global-navigation nav .feds-gnav-items {
    align-items: center;
    padding-left: 0;
    margin: 0;
    display: flex;
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .feds-link {
    letter-spacing: var(--s2a-typography-letter-spacing-label);
  }
  .global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link {
    opacity: 60%;
    font-weight: var(--s2a-font-weight-adobe-clean-bold);
    font-size: var(--s2a-typography-font-size-label);
    line-height: var(--s2a-typography-line-height-label);
    letter-spacing: var(--s2a-typography-letter-spacing-label);
    padding: var(--s2a-spacing-sm);
  }

  .global-navigation.site-pivot:not(:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)) .feds-gnav-items:has(.feds-link:hover) > li > .feds-link:not(:hover) {
    opacity: 0.65;
  }


  .global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link[aria-expanded="true"],
  .global-navigation.site-pivot:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-gnav-items > li > .feds-link:hover {
    opacity: 1;
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link {
    position: relative;
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link .chevron-down {
    margin-top: 3px;
    margin-left: 6px;
    flex-shrink: 0;
    transition: transform 0.15s ease;
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link:has(~ .feds-popup:popover-open) .chevron-down {
    transform: rotate(180deg);
  }

  .feds-popup .feds-popup-header {
    display: none;
  }

  .feds-popup > div {
    max-width: 1920px;
  }
  .feds-popup .feds-product-card__title {
    font-weight: var(--s2a-font-weight-adobe-clean-bold);
    font-size: var(--s2a-typography-font-size-eyebrow);
    line-height: var(--s2a-typography-line-height-eyebrow);
    letter-spacing: var(--s2a-typography-letter-spacing-eyebrow);
    font-family: var(--feds-font-family);
  }
}

/* =========================================
   Responsive: Mobile (max-width: 1023px)
   ========================================= */

@media (max-width: 1023px) {
  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link {
    width: 100%;
    justify-content: space-between;
    text-align: left;
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .feds-link {
    font-family: var(--feds-heading-font-family);
    font-weight: var(--s2a-font-weight-adobe-clean-black);
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link .chevron-down {
    order: 2;
    margin-left: var(--s2a-spacing-xs);
    flex-shrink: 0;
    transform: rotate(-90deg) scale(2.5);
  }

  .global-navigation.site-pivot .feds-gnav-items > li > .mega-menu.feds-link .chevron-down path {
    stroke-width: 0.5;
  }

  .feds-popup {
    inset: calc(var(--s2a-spacing-64) + var(--s2a-spacing-8) - 1px) 0 0 0;
  }

  .feds-popup .feds-product-card {
    gap: var(--s2a-spacing-2xl);     
    border-radius: var(--s2a-border-radius-24);
  }

  body:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) {
    overflow: hidden;
    scrollbar-gutter: stable;
  }

  header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {
    border-radius: 0;
  }

  .feds-popup .feds-product-card__subtitle {
    margin-top: var(--s2a-spacing-xs);
  }
}

/* =========================================
   Scroll Animations
   ========================================= */

@media (min-width: 1920px) {
  header.global-navigation nav:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open)::after {
    left: calc(0px - var(--s2a-spacing-xs) - (100vw - 1920px) / 2);
  }

  header.global-navigation nav .feds-popup > div {
    margin: 0 auto;
  }
}

/* =========================================
   Popover Animations
   ========================================= */


@media (min-width: 1024px) {
  .feds-popup {
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    background-color: transparent;
    opacity: 0;
    overflow: hidden;
    max-height: calc(100dvh - var(--s2a-spacing-64));
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    transition:
      display 0.48s allow-discrete,
      overlay 0.48s allow-discrete,
      opacity 0.48s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0s;
  }

  .feds-popup:popover-open {
    background-color: transparent;
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition-delay: 0.15s;
  }

  .feds-popup:popover-open > :not(.feds-popup-header) {
    overflow-y: auto;
    max-height: calc(100dvh - var(--s2a-spacing-64));
  }

  @starting-style {
    .feds-popup:popover-open {
      background-color: rgba(255,255,255,0.51);
      opacity: 0;
      clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    }
  }

  nav::backdrop {
    background-color: rgba(0, 0, 0, 0);
    backdrop-filter: blur(0px);
    inset: 0 0 0 0;
    transition:
      opacity 0.3s ease,
      background-color 0.3s ease,
      backdrop-filter 0.3s ease;
  }

  nav:has(.feds-popup:popover-open)::backdrop {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.60);
    backdrop-filter: blur(32px);
  }

  @starting-style {
    nav::backdrop {
      opacity: 0;
      background-color: rgba(0, 0, 0, 0);
      backdrop-filter: blur(0px);
    }
  }
}

/* =========================================
   Content Entrance Animations (Desktop Only)
   ========================================= */

@keyframes feds-slide-up {
  from {
    transform: translateY(6px);
  }
  to {
    transform: translateY(0);
  }
}
.feds-popup:popover-open {
  /* Animation Variables */
  --feds-anim-duration: 0.35s;
  --feds-anim-panel-delay: 0.18s;
  --feds-anim-stagger-interval: 25ms;
  --feds-anim-stagger-start: 0.20s;
}
.feds-popup:popover-open .product-list ul[role="tabpanel"] > li {
  transform: translateY(6px);
  animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;
}
.feds-popup:popover-open .product-list ul[role="tabpanel"] > li {
  transform: translateY(6px);
  animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;
}

@media (min-width: 1024px) {

  /* 1. Pane Content (Base Slide & Fade) */
  .feds-popup:popover-open > div {
    transform: translateY(6px);
    animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;
    animation-delay: var(--feds-anim-panel-delay);
  }

  /* 2. Filters and Cards (Staggered) */
  .feds-popup:popover-open .feds-gnav-cards > li,
  .feds-popup:popover-open .product-list ul.tabs > li {
    transform: translateY(6px);
    animation: feds-slide-up var(--feds-anim-duration) ease-out forwards;
  }

  .product-list .tab-content [role="tabpanel"] {
    opacity: 0;
    transition:
      display 0.48s allow-discrete,
      opacity 0.48s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0.2s;
    &[hidden] {
      transition: unset;
    }
  }

  .product-list .tab-content [role="tabpanel"]:not([hidden]) {
    opacity: 1;
  }

  @starting-style {
    .product-list .tab-content [role="tabpanel"]:not([hidden]) {
      opacity: 0;
    }
  }
}
/* =========================================
   Unav App Switcher Fix
   ========================================= */

header.global-navigation:has(.unav-comp-app-switcher-open) nav {
  backdrop-filter: none;
  transform: none;
  transition: none;
  background: transparent;
}

header.global-navigation .universal-nav-container .universal-nav-tray .unav-comp-overlay {
  height: 100vh;
  width: 100vw;
}

/* =========================================
   Menu Wrapper (Mobile Fade In)
   ========================================= */

@keyframes mobile-main-menu-slide-in {
  from {
    opacity: 0;
    transform: translateX(18px);
  } to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes main-menu-items-exit {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-40px);
  }
}

@keyframes sub-menu-items-enter {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes sub-menu-items-exit {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(18px);
  }
}

@keyframes main-menu-items-re-enter {
  from {
    opacity: 0;
    transform: translateX(-18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fade-in {
  from { opacity: 0; display: none; }
  to   { opacity: 1; display: block; }
}

@keyframes fade-out {
  from { opacity: 1; display: block; }
  to   { opacity: 0; display: none; }
}

@media (max-width: 1023px) {
  .global-navigation nav > ul > li.feds-menu-wrapper {
    position: fixed;
    top: var(--s2a-spacing-64);
    left: 0;
    right: var(--s2a-spacing-20);
    flex-direction: column;
    height: calc(100dvh - var(--s2a-spacing-64));
    border: 0;
    width: 100%;
    opacity: 0;
    display: flex;
    visibility: hidden;
    color: var(--s2a-color-gray-1000);
    background-color: transparent;
    padding: 0;
  }
  
  .global-navigation nav > ul > li.feds-menu-wrapper.feds-menu-active {
    transition: opacity 0.2s ease, visibility 0s linear 0.2s;
  }
  
  .global-navigation nav > ul > li.feds-menu-wrapper:popover-open {
    display: flex;
    translate: 0;
    opacity: 1;
    z-index: 2;
    transition: translate 0.4s ease-out, opacity 0.4s ease, visibility 0s linear 0s;
    visibility: visible;
    align-items: flex-start;
    padding: 0;
    margin-top: 0;
  }
  
  .global-navigation nav > ul > li.feds-menu-wrapper:popover-open .feds-gnav-items {
    align-items: flex-start;
    padding: var(--s2a-spacing-xs) var(--s2a-spacing-lg) var(--s2a-spacing-sm);
    width: calc(100% - var(--s2a-spacing-3xl));
  }

  .global-navigation nav > ul > li.feds-menu-wrapper:popover-open {
    & .feds-gnav-items > li {
      opacity: 0;
      transform: translateX(18px);
      animation: mobile-main-menu-slide-in 0.35s cubic-bezier(0.42, 0, 0, 1) forwards;
    }
  
    & .feds-gnav-items > li:nth-child(1) { animation-delay: 0.18s; }
    & .feds-gnav-items > li:nth-child(2) { animation-delay: 0.24s; }
    & .feds-gnav-items > li:nth-child(3) { animation-delay: 0.30s; }
    & .feds-gnav-items > li:nth-child(4) { animation-delay: 0.36s; }
    & .feds-gnav-items > li:nth-child(5) { animation-delay: 0.42s; }
    & .feds-gnav-items > li:nth-child(6) { animation-delay: 0.48s; }
    & .feds-gnav-items > li:nth-child(7) { animation-delay: 0.54s; }
    & .feds-gnav-items > li:nth-child(8) { animation-delay: 0.60s; }
    & .feds-gnav-items > li:nth-child(9) { animation-delay: 0.66s; }
    & .feds-gnav-items > li:nth-child(10) { animation-delay: 0.72s; }
  }

  .feds-nav-toggle path {
    transform-origin: 7px 3.5px;
    transition: transform 0.35s cubic-bezier(.4,0,.2,1);
  }
  
  .global-navigation:has(.feds-menu-wrapper:popover-open, .feds-popup:popover-open) .feds-nav-toggle svg {
    height: 11px;
  }
  
  .global-navigation:has(.feds-menu-wrapper:popover-open, .feds-popup:popover-open) .feds-nav-toggle path:first-child {
    transform: translateY(-2.75px) rotate(-45deg) scaleX(1.25);
  }
  .global-navigation:has(.feds-menu-wrapper:popover-open, .feds-popup:popover-open) .feds-nav-toggle path:last-child {
    transform: translateY(2.75px) rotate(45deg) scaleX(1.25);
  }
  
  header.global-navigation > nav > ul > li.feds-menu-wrapper > ul.feds-gnav-items {
    /* open subscreen */
    &.subscreen-opening {
      & > li {
        opacity: 1;
        transform: translateX(0);
        animation: main-menu-items-exit 0.5s cubic-bezier(0.42, 0, 0, 1) forwards;
      }
      & > li:nth-child(1) { animation-delay: 0s; }
      & > li:nth-child(2) { animation-delay: 0.025s; }
      & > li:nth-child(3) { animation-delay: 0.05s; }
      & > li:nth-child(4) { animation-delay: 0.075s; }
      & > li:nth-child(5) { animation-delay: 0.1s; }
  
      /* target the popover descendant when it is open */
      & .feds-popup:popover-open {
        opacity: 0;
        animation: fade-in 0s linear 0.3s forwards; /* zero-duration instant jump after delay */
  
        & .feds-popup-header {
          opacity: 0;
          transform: translateX(18px);
          animation: sub-menu-items-enter 0.5s forwards cubic-bezier(0.42, 0, 0, 1) 0.3s;
        }
  
        & .tabs {
          opacity: 0;
          transform: translateX(18px);
          animation: sub-menu-items-enter 0.5s forwards cubic-bezier(0.42, 0, 0, 1);
          animation-delay: 0.36s;
        }
  
        & .feds-gnav-cards > li {
          opacity: 0;
          transform: translateX(18px);
          animation: sub-menu-items-enter 0.5s forwards cubic-bezier(0.42, 0, 0, 1);
        }
        & .feds-gnav-cards > li:nth-child(1) { animation-delay: 0.36s; }
        & .feds-gnav-cards > li:nth-child(2) { animation-delay: 0.42s; }
      }
    }
    /* close subscreen */
    &.subscreen-closing {
      & > li {
        opacity: 0;
        transform: translateX(-18px);
        animation: main-menu-items-re-enter 0.26s ease forwards 0.24s;
      }
      & > li:nth-child(1) { animation-delay: 0.24s; }
      & > li:nth-child(2) { animation-delay: 0.27s; }
      & > li:nth-child(3) { animation-delay: 0.30s; }
      & > li:nth-child(4) { animation-delay: 0.33s; }
      & > li:nth-child(5) { animation-delay: 0.36s; }
  
      /* target the popover descendant when it is open */
      & .feds-popup:popover-open {
        & .feds-popup-header {
          opacity: 1;
          transform: translateX(0px);
          animation: sub-menu-items-exit 0.2s forwards ease;
        }
  
        & .tabs {
          opacity: 1;
          transform: translateX(0px);
          animation: sub-menu-items-exit 0.2s forwards ease;
        }
  
        & .feds-gnav-cards > li {
          opacity: 1;
          transform: translateX(0px);
          animation: sub-menu-items-exit 0.2s forwards ease;
        }
        & .feds-gnav-cards > li:nth-child(1) { animation-delay: 0.04s; }
        & .feds-gnav-cards > li:nth-child(2) { animation-delay: 0.08s; }
      }
    }
  }

  header.global-navigation.feds-header-scrolled:has(.unav-comp-app-switcher-open) .feds-brand-image svg,
  header.global-navigation.feds-header-scrolled:has(.unav-comp-app-switcher-open) .feds-nav-toggle svg {
    animation: none;
    color: var(--s2a-color-gray-1000);
  }
}

ul.feds-gnav-cards,
ul[role="tabpanel"],
.product-list ul.tabs {
  & > li:nth-child(1) { animation-delay: 0.025s; }
  & > li:nth-child(2) { animation-delay: 0.05s; }
  & > li:nth-child(3) { animation-delay: 0.075s; }
  & > li:nth-child(4) { animation-delay: 0.1s; }
  & > li:nth-child(5) { animation-delay: 0.125s; }
  & > li:nth-child(6) { animation-delay: 0.15s; }
  & > li:nth-child(7) { animation-delay: 0.175s; }
  & > li:nth-child(8) { animation-delay: 0.2s; }
  & > li:nth-child(9) { animation-delay: 0.225s; }
  & > li:nth-child(10) { animation-delay: 0.25s; }
}

/* =========================================
   Brand Container
   ========================================= */

.feds-brand-container {
  display: flex;
  flex-shrink: 0;
}

li.feds-brand-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

header.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) nav .feds-brand-image svg,
header.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) nav .feds-nav-toggle svg,
header.global-navigation.feds-header-scrolled nav .feds-brand-image svg {
  color: var(--s2a-color-gray-1000);
}

/* =========================================
   Brand
   ========================================= */

.feds-brand {
  align-items: center;
  outline-offset: var(--s2a-spacing-2xs);
  padding: 0 var(--s2a-spacing-sm) 0 var(--s2a-spacing-md);
  column-gap: 10px;
}

.feds-brand-image svg {
  width: 100%;
  display: block;
}

/* =========================================
   Brand Image (Mobile / Desktop variants)
   ========================================= */

.feds-brand-image svg {
  color: var(--s2a-color-gray-25);
}

.feds-brand-image.desktop-brand {
  display: none;
}

.feds-brand-image.mobile-brand {
  display: inherit;
}

.feds-brand-image.mobile-brand svg {
  height: var(--s2a-spacing-md);
  width: 18px; /* no token for 18px */
}

.feds-brand-image.desktop-brand svg {
  width: 67px;
}

/* For light background */
.feds-brand-image {
  & img:nth-child(1) { display: inherit; }
  & img:nth-child(2) { display: none; }
}

/* For dark background */
.feds-dark-bg {
  & .feds-brand-image {
    & img:nth-child(1) { display: none; }
    & img:nth-child(2) { display: inherit; }
  }
}

/* same behavior for both "scrolled" and "popup open" states (considering for transparent-white/light background only)*/
:is(.feds-header-scrolled, .global-navigation:has(.feds-popup:popover-open)) {
  & .feds-brand-wrapper .feds-brand-image {
    & img:nth-child(1) { display: inherit; }
    & img:nth-child(2) { display: none; }
  }
}

/* =========================================
   Animations
   ========================================= */

@media (max-width: 1023px) {
  @keyframes brand-fade {
    from {
      opacity: 1;
      visibility: visible;
    }
    to {
      opacity: 0;
      visibility: hidden;
    }
  }
  header.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-brand,
  header.global-navigation:has(.feds-menu-active) .feds-brand {
    animation: brand-fade 0.3s;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }
  header.global-navigation .feds-nav-toggle {
    transform: translateX(0);
    transition: transform 0.3s ease;
  }
  header.global-navigation:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-nav-toggle {
    transform: translateX(-30px);
  }
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  li.feds-brand-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 0;
  }

  .feds-brand-image.desktop-brand {
    display: inherit;
  }

  header:has(.feds-popup:popover-open, .feds-menu-wrapper:popover-open) .feds-brand-image svg {
    color: var(--s2a-color-gray-1000);
  }

  .feds-brand-image.mobile-brand {
    display: none;
  }
}

/* Mega Menu grid structure for links-card and promo-card */

/* =========================================
   Gnav Cards Grid (base)
   ========================================= */

.feds-gnav-cards > li:has(> :nth-child(2)) {
  display: flex;
  flex-direction: column;
  gap: var(--s2a-spacing-2xs);
}

/* =========================================
   Product Link in mobile on product list
   ========================================= */

.feds-popup-header .product-links .feds-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--s2a-color-content-default);
  text-decoration: none;
  font-size: var(--s2a-font-size-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: 18px;
  white-space: nowrap;
  padding: 0;
  font-family: var(--feds-font-family);
}

.feds-popup-header .product-links .feds-link svg {
  width: 5px;
  height: 8px;
  flex-shrink: 0;
}

ul.tabs .product-links {
  display: none;
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  /* Responsive: fit all columns within width (no promo-card) */
  .feds-gnav-cards:not(:has(.promo-card)) > li:has(> :nth-child(2)) {
    gap: var(--s2a-spacing-xs);
    flex: 2 1 0;
    flex-direction: row;
  }

  .feds-gnav-cards:not(:has(.promo-card)) > li:has(> :nth-child(2)) article {
    flex: 1 1 0;
    min-width: 0;
  }

  /* Legacy: fixed widths when promo-card is present */
  .feds-gnav-cards:has(.promo-card) > li:has(> :nth-child(2)) {
    gap: var(--s2a-spacing-xs);
  }

  .feds-gnav-cards:has(.promo-card) > li:has(.promo-card, .links-card) {
    width: calc(33.33% - 5.33px);
  }

  .feds-popup .feds-gnav-cards:has(.promo-card, .links-card) {
    align-items: stretch;
  }

  .feds-popup .feds-gnav-cards:has(.promo-card, .links-card) article {
    height: 100%;
  }

  .feds-popup-header .product-links {
    display: none;
  }

  ul.tabs .product-links {
    display: block;
  }

  ul.tabs .product-links .feds-link {
    font-family: var(--feds-font-family);
    padding: var(--s2a-spacing-md) var(--s2a-spacing-lg);
  }
}

/* =========================================
   Large Desktop (min-width: 1280px) — promo-card layout only
   ========================================= */

@media (min-width: 1280px) {
  .feds-gnav-cards:has(.promo-card) > li:has(.promo-card, .links-card) {
    width: calc(25% - 6px);
  }

  .feds-gnav-cards:has(.promo-card) > li:has(.promo-card) {
    width: calc(50% - 4px);
  }

  .feds-gnav-cards:has(.promo-card) > li:has(> :nth-child(2)) {
    width: calc(50% - 4px);
    flex-direction: row;
  }

  .feds-gnav-cards:has(.promo-card) > li:has(> :nth-child(2)) article {
    width: calc(50% - 4px);
  }
}

/* =========================================
   Gnav Cards Container
   ========================================= */

.feds-popup .feds-gnav-cards {
  list-style: none;
  margin: 0;
  padding: var(--s2a-spacing-lg);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--s2a-spacing-2xs);
  align-items: stretch;
}

.feds-popup .feds-gnav-cards > li {
  min-width: 0;
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  .feds-popup .feds-gnav-cards {
    display: flex;
    flex-wrap: nowrap;
    gap: var(--s2a-spacing-xs);
    overflow-x: auto;
    width: 100%;
    padding-top: 0;
  }

  .feds-popup .feds-gnav-cards > li {
    flex: 1 1 0;
    min-width: 0;
  }

  .feds-popup .feds-gnav-cards:has(.promo-card) > li {
    flex: 0 0 auto;
  }
}

/* =========================================
   Promo Card
   ========================================= */

.feds-gnav-cards .promo-card {
  position: relative;
  height: 199px;
}

.feds-gnav-cards .promo-card__bg {
  height: 100%;
  width: 100%;
  display: block;
  position: absolute;
}

.feds-gnav-cards .promo-card__bg-image {
  border-radius: var(--s2a-border-radius-24);
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.feds-gnav-cards .promo-card__content {
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  width: 100%;
  height: 100%;
}

.feds-gnav-cards .promo-card__icon {
  position: absolute;
  top: var(--s2a-spacing-md);
  left: var(--s2a-spacing-md);
  width: var(--s2a-spacing-lg);
  height: var(--s2a-spacing-lg);
}

.feds-gnav-cards .promo-card__text-content {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  padding: var(--s2a-spacing-md);
}

.feds-gnav-cards .promo-card__price,
.feds-gnav-cards .promo-card__title {
  margin: 0;
  color: var(--s2a-color-gray-25);
}

.feds-gnav-cards .promo-card__price {
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  font-size: var(--s2a-font-size-md);
  line-height: var(--s2a-font-line-height-24);
  /* No token for percentage */
  letter-spacing: -1%;
}

.feds-gnav-cards .promo-card__title {
  font-weight: var(--s2a-font-weight-adobe-clean-black);
  font-size: var(--s2a-typography-font-size-title-4);
  line-height: var(--s2a-typography-line-height-title-4-temp);
  letter-spacing: var(--s2a-typography-letter-spacing-title-4);
  font-family: var(--feds-heading-font-family);
}

/* =========================================
   Promo Card CTA
   ========================================= */

.feds-gnav-cards .promo-card__cta {
  display: block;
  margin-top: var(--s2a-spacing-lg);
}

.feds-gnav-cards .promo-card__cta .feds-secondary-cta {
  letter-spacing: 0;
  border: none;
  background: var(--s2a-color-gray-25);
  color: var(--s2a-color-gray-1000);
  padding: 11px var(--s2a-spacing-lg) var(--s2a-spacing-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  font-size: var(--s2a-typography-font-size-label);
  line-height: var(--s2a-typography-line-height-label);
  letter-spacing: var(--s2a-typography-letter-spacing-label);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.feds-gnav-cards .promo-card__cta .feds-secondary-cta:hover,
.feds-gnav-cards .promo-card__cta .feds-secondary-cta:focus {
  background: var(--s2a-color-gray-1000);
  color: var(--s2a-color-gray-25);
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  .feds-gnav-cards .promo-card {
    height: 100%;
    min-height: 420px;
  }

  .feds-gnav-cards .promo-card__bg-image {
    border-radius: var(--s2a-border-radius-md);
  }

  .feds-gnav-cards .promo-card__cta {
    margin-top: var(--s2a-spacing-md);
  }
}

/* =========================================
   Responsive: Large Desktop (min-width: 1280px)
   ========================================= */

@media (min-width: 1280px) {
  .feds-gnav-cards .promo-card {
    min-height: auto;
  }

  .feds-gnav-cards .promo-card__bg-image {
    border-radius: var(--s2a-border-radius-12);
  }

  .feds-gnav-cards .promo-card__icon {
    position: absolute;
    top: var(--s2a-spacing-lg);
    left: var(--s2a-spacing-lg);
  }

  .feds-gnav-cards .promo-card__text-content {
    width: 100%;
    box-sizing: border-box;
    padding: var(--s2a-spacing-lg);
  }

  .feds-gnav-cards .promo-card__cta {
    position: absolute;
    bottom: var(--s2a-spacing-lg);
    right: var(--s2a-spacing-lg);
    margin-top: 0;
  }
}

/* =========================================
   Links Card
   ========================================= */

.feds-popup .links-card {
  border-radius: var(--s2a-border-radius-24); /* Don't have a token */
  background: var(--s2a-color-gray-25);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--s2a-spacing-xl) var(--s2a-spacing-lg);
}

.feds-popup .links-card .links-card-title {
  margin: 0 0 var(--s2a-spacing-sm);
  font-size: var(--s2a-typography-font-size-title-4);
  line-height: var(--s2a-typography-line-height-title-4-temp);
  letter-spacing: var(--s2a-typography-letter-spacing-title-4);
  font-weight: var(--s2a-font-weight-adobe-clean-black);
  color: var(--s2a-color-gray-1000);
  font-family: var(--feds-heading-font-family);
}



/* =========================================
   Links Card List
   ========================================= */

.feds-popup .links-card .links-card-links {
  list-style: none;
  margin: 0;
  padding: 0;
  line-height: 120%;
}

.feds-popup .links-card .links-card-links li {
  display: flex;
  padding: var(--s2a-spacing-xs) 0;
}

.feds-popup .links-card .links-card-links .feds-link {
  padding: 0;
  color: var(--s2a-color-gray-1000);
  font-size: var(--s2a-font-size-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-regular);
  display: inline-flex;
}

/* =========================================
   Links Card Footer
   ========================================= */

.feds-popup .links-card .links-card-footer {
  width: 100%;
  margin-top: var(--s2a-spacing-lg);
}

.feds-popup .links-card .links-card-footer .feds-secondary-cta {
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  background-color: transparent;
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  .feds-popup .links-card {
    border-radius: var(--s2a-border-radius-16); /* Don't have a token */
    padding: var(--s2a-spacing-lg) var(--s2a-spacing-lg) var(--s2a-spacing-md);
  }

  .feds-popup .links-card .links-card-footer .feds-secondary-cta {
    color: var(--s2a-color-gray-1000);
    background-color: transparent;
  }
  .feds-popup .links-card .links-card-footer .feds-secondary-cta:hover {
    color: var(--s2a-color-gray-25);
    background-color:var(--s2a-color-gray-1000);
  }
}

/* =========================================
   Responsive: Large Desktop (min-width: 1280px)
   ========================================= */

@media (min-width: 1280px) {
  .feds-popup .links-card {
    padding-bottom: var(--s2a-spacing-lg);
  }
} 

/* =========================================
   Product List Container
   ========================================= */

.feds-popup .product-list {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  gap: var(--s2a-spacing-lg);
  padding: var(--s2a-spacing-lg);
  border-radius: var(--s2a-border-radius-md);
  width: 100%;
}

.product-list .tabs,
.product-list .tab-content,
.product-list .product-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* =========================================
   Tabs
   ========================================= */

.product-list .tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  background-color: transparent;
}

.feds-popup .product-list .tabs {
  margin-left: calc(0px - var(--s2a-spacing-lg));
  margin-right: calc(0px - var(--s2a-spacing-lg));
  padding: 0 var(--s2a-spacing-lg);
}

.product-list .tabs::-webkit-scrollbar {
  display: none;
}

.product-list .tabs li {
  list-style: none;
  flex: 0 0 auto;
}

.product-list .tabs button.tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  white-space: nowrap;
  min-height: 40px;
  border: 0;
  /* No token: 75px radius */
  border-radius: 75px;
  padding: var(--s2a-spacing-md) var(--s2a-spacing-lg);
  text-align: center;
  font-family: var(--feds-font-family);
  font-size: var(--s2a-font-size-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: 8px;
  color: var(--s2a-color-content-default);
  background: rgb(0 0 0 / 4%);
  cursor: pointer;
}

.product-list .tabs button.tab[aria-selected="true"] {
  background: var(--s2a-color-gray-1000);
  color: var(--s2a-color-gray-25);
}

.product-list .tabs button.tab:hover:not([aria-selected="true"]) {
  color: var(--s2a-color-gray-25);
  background-color: var(--s2a-color-content-subtle);
}

/* =========================================
   Tab Content / Tabpanels
   ========================================= */

.product-list .tab-content > li {
  list-style: none;
}

.product-list .tab-content [role="tabpanel"][hidden] {
  display: none;
}

.product-list .tab-content [role="tabpanel"] {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--s2a-spacing-2xs);
  padding: 0;
  margin: 0;
  list-style: none;
}

.product-list .tab-content [role="tabpanel"] li {
  display: flex;
}

.product-list .tab-content [role="tabpanel"] .feds-product-card {
  display: flex;
  flex-direction: column;
  min-height: 120px;
  flex: 1;
  background-color: var(--s2a-color-gray-25);
  justify-content: space-between;
  outline-offset: -1px;
}

.feds-popup .product-list .tab-content [role="tabpanel"] .feds-product-card:hover {
  background: var(--s2a-color-gray-1000);
}

.feds-popup .product-list .tab-content [role="tabpanel"] .feds-product-card:hover .feds-product-card__title {
  color: var(--s2a-color-gray-25);
}

/* =========================================
   Product Links
   ========================================= */

.product-list .product-links a {
  color: var(--s2a-color-content-default);
}

.product-list .product-links .feds-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.product-list .product-links .feds-link svg {
  width: 3px;
  height: 6px;
  flex-shrink: 0;
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  .feds-popup .product-list {
    grid-template-columns: 1fr minmax(0, 3fr);
    gap: var(--s2a-spacing-xs);
    padding: 0 var(--s2a-spacing-lg) var(--s2a-spacing-lg);
  }

  .product-list .tabs {
    display: block;
    overflow: visible;
  }

  .feds-popup .product-list .tabs {
    margin: 0;
    padding: 0;
  }

  .product-list .tabs li {
    flex: unset;
  }

  .product-list .tabs button.tab {
    width: auto;
    min-height: 44px;
    margin-bottom: var(--s2a-spacing-2xs);
  }

  .product-list .tab-content [role="tabpanel"] {
    grid-template-columns: repeat(3, 1fr);
    gap: var(--s2a-spacing-xs);
  }
}

/* =========================================
   Responsive: Very Large Desktop (min-width: 1920px)
   ========================================= */

@media (min-width: 1920px) {
  .feds-popup .product-list {
    grid-template-columns: auto minmax(0,3fr);
  }
  .feds-popup .product-list .tab-content [role="tabpanel"] {
    grid-template-columns: repeat(5, 1fr);
  }
  .feds-popup .product-list .tabs {
    margin-right: var(--s2a-spacing-4xl);
  }
}

.product-hint {
  display: none;
}

/* =========================================
   Panels Container
   ========================================= */

.global-navigation .panels {
  list-style: none;
  margin: 0 auto;
  padding: 36px clamp(var(--s2a-spacing-lg), 4vw, 56px) var(--s2a-spacing-40);
  gap: var(--s2a-spacing-xl);
  width: min(1200px, 100%);
  box-sizing: border-box;
  color: var(--s2a-color-gray-1000);
  width: 100%;
}

.panels > li {
  min-width: 0;
  /* No token: design #f6f6f6; using gray-75 */
  background-color: var(--s2a-color-gray-75);
  border-radius: var(--s2a-border-radius-md);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.feds-popup .panels .feds-secondary-cta {
  margin-top: auto;
  margin-bottom: var(--s2a-spacing-sm);
  align-self: center;
  width: 75%;
}

.panels h4 {
  font-family: var(--feds-heading-font-family);
  font-size: var(--s2a-font-size-2xl);
  line-height: var(--s2a-font-line-height-20);
  margin-left: var(--s2a-spacing-lg);
}

/* =========================================
   Link Panel
   ========================================= */

.global-navigation.site-pivot .panels .link-panel {
  list-style: none;
  margin: 0 0 0 var(--s2a-spacing-lg);
  padding: 0;
}

.global-navigation.site-pivot .panels .link-panel + .feds-link {
  color: var(--s2a-color-gray-1000);
  margin-left: var(--s2a-spacing-lg);
  padding-left: 0;
  margin-top: auto;
}

.global-navigation.site-pivot .panels .link-panel + .feds-link::after {
  content: "";
  width: var(--s2a-spacing-2xs);
  height: var(--s2a-spacing-2xs);
  border-right: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);
  border-top: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);
  transform: translateY(8%) translateX(var(--s2a-spacing-xs)) rotate(45deg);
}

.panels .link-panel .feds-link,
.panels .panel-footer-link .feds-link {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: var(--s2a-spacing-sm) 0;
  text-decoration: none;
  font-size: var(--s2a-font-size-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: 1.35;
  color: var(--s2a-color-gray-1000);
}

.panels .link-panel-container > .feds-secondary-cta,
.panels > li > .feds-secondary-cta {
  margin-top: var(--s2a-spacing-sm);
}

/* =========================================
   List Image Panel
   ========================================= */

.panels > li:has(> .list-image-panel) {
  background-color: var(--s2a-color-gray-1000);
  border: var(--s2a-border-width-lg) var(--s2a-color-gray-1000) solid;
}

.list-image-panel {
  display: flex;
  background-color: transparent;
  color: var(--s2a-color-gray-25);
  height: 100%;
  align-items: stretch;
  gap: var(--s2a-spacing-sm);
}

.list-image-panel .link-panel-container {
  display: flex;
  flex-direction: column;
  min-width: 250px;
}

.panels .list-image-panel .feds-link {
  color: var(--s2a-color-gray-25);
}

.panels .list-image-panel .feds-secondary-cta {
  color: var(--s2a-color-gray-25);
  margin: auto 0 var(--s2a-spacing-sm) 0;
  width: calc(100% - var(--s2a-spacing-lg));
}

.panels .list-image-panel .feds-secondary-cta:hover {
  color: var(--s2a-color-gray-1000);
}

.panels .list-image-panel li {
  border-radius: var(--s2a-border-radius-sm);
  padding: var(--s2a-spacing-sm);
}

.panels .list-image-panel li a.feds-link {
  padding: 0;
}

.panels .list-image-panel li:hover {
  background-color: var(--s2a-color-gray-25);
  position: relative;
}

.panels .list-image-panel li:hover .feds-link {
  color: var(--s2a-color-gray-1000);
}

.panels .list-image-panel li:hover .feds-link::after {
  content: "";
  position: absolute;
  right: var(--s2a-spacing-sm);
  width: var(--s2a-spacing-2xs);
  height: var(--s2a-spacing-2xs);
  border-right: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);
  border-top: var(--s2a-border-width-md) solid var(--s2a-color-gray-1000);
  transform: translateY(8%) translateX(100%) rotate(45deg);
}

.list-image-panel picture {
  display: block;
}

.list-image-panel picture img {
  display: block;
  height: 100%;
  max-height: 100%;
  width: auto;
  /* No token: 14px radius */
  border-radius: 14px;
  object-fit: cover;
}

/* =========================================
   Image Panel
   ========================================= */

.image-panel {
  position: relative;
  border-radius: var(--s2a-border-radius-md);
  overflow: hidden;
  min-height: 320px;
  isolation: isolate;
  display: grid;
}

.image-panel > picture {
  display: block;
  height: 100%;
  grid-area: 1 / 1;
}

.image-panel > picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-panel .overlay {
  grid-area: 1 / 1;
  display: grid;
  gap: var(--s2a-spacing-sm);
  padding: 18px 18px 20px;
  color: var(--s2a-color-gray-25);
  /* Unsure: 80% vs 64% token */
  background: linear-gradient(
    180deg,
    rgb(0 0 0 / 0%) 0%,
    var(--s2a-color-transparent-black-64) 70%
  );
  grid-template-columns: 300px auto auto;
  grid-template-rows: var(--s2a-spacing-3xl) auto 50px;
}

.image-panel .icon {
  width: 34px;
  height: 34px;
  grid: 1 / 1 / 1 / 1;
}

.image-panel .icon img {
  display: block;
  width: 100%;
  height: 100%;
}

.image-panel .text {
  display: grid;
  gap: 3px;
  grid-area: 3 / 1 / 3 / 1;
}

.image-panel .text span:first-child {
  font-size: var(--s2a-font-size-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  line-height: 1.2;
}

.image-panel .text span:last-child {
  font-family: var(--feds-heading-font-family);
  font-size: 21px;
  font-weight: var(--s2a-font-weight-adobe-clean-extrabold);
  line-height: 1.2;
}

.image-panel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 34px;
  padding: 0 14px;
  border-radius: var(--s2a-border-radius-round);
  color: var(--s2a-color-gray-1000);
  text-decoration: none;
  font-size: var(--s2a-font-size-sm);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  background-color: var(--s2a-color-gray-25);
  backdrop-filter: blur(1px);
  grid-area: 3 / 3 / 3 / 3;
  justify-self: end;
}

/* =========================================
   Responsive: Mobile (max-width: 1023px)
   ========================================= */

@media (max-width: 1023px) {
  .panels {
    display: block !important;
    grid-template-columns: none !important;
    grid-template-rows: none !important;
    padding: 22px var(--s2a-spacing-md) 28px;
  }

  .panels > li + li {
    margin-top: 22px;
  }

  .list-image-panel {
    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "image"
      "list";
    row-gap: 14px;
  }
}

/* =========================================
   Featured Card
   ========================================= */

.feds-popup .featured-card {
  border-radius: 24px;
  background: var(--s2a-color-gray-25);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: var(--s2a-spacing-lg);
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
  height: 100%;
}

.feds-popup .featured-card .featured-eyebrow {
  /* No token: design uses custom gray; using content-subtle */
  color: var(--s2a-color-content-body-subtle);
  font-family: var(--body-font-family);
  font-size: var(--s2a-typography-font-size-label);
  font-weight: var(--s2a-font-weight-adobe-clean-bold);
  letter-spacing: var(--s2a-typography-letter-spacing-label);
  line-height: var(--s2a-typography-line-height-label);
}

.feds-popup .featured-card h2 {
  margin: 0;
  font-family: var(--feds-heading-font-family);
  font-size: var(--s2a-typography-font-size-title-4);
  line-height: var(--s2a-typography-line-height-title-4-temp);
  letter-spacing: var(--s2a-typography-letter-spacing-title-4);
  color: var(--s2a-color-content-default);
  padding: var(--s2a-spacing-md) 0 var(--s2a-spacing-xs) 0;
  font-weight: var(--s2a-font-weight-adobe-clean-black);
}

.featured-card .featured-subtitle {
  font-size: var(--s2a-font-size-sm);
  line-height: 120%;
  color: var(--s2a-color-content-subtle);
}

.featured-card .feds-link {
  padding: var(--s2a-spacing-md) 0;
  color: var(--s2a-color-gray-1000);
  display: inline-flex;
  gap: 6px;
}

.featured-card span {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
}

.featured-card span svg {
  margin-top: 2px;
  color: var(--s2a-color-gray-1000);
  width: 3px;
  height: 8px;
}

.featured-card a.feds-secondary-cta {
  background: var(--s2a-color-gray-1000);
  color: var(--s2a-color-gray-25);
}

/* =========================================
   Featured Card Footer
   ========================================= */

.featured-card .footer-container {
  width: 100%;
}

.featured-card .footer-container a {
  width: 100%;
  box-sizing: border-box;
}

.featured-card .footer-container a.feds-secondary-cta:hover {
  background: var(--s2a-color-gray-1000);
}

/* =========================================
   Responsive: Desktop (min-width: 1024px)
   ========================================= */

@media (min-width: 1024px) {
  .feds-popup .featured-card {
    border-radius: 12px;
  }

  .featured-card a.feds-secondary-cta {
    background: transparent;
    color: var(--s2a-color-gray-1000);
    border: var(--s2a-border-width-sm) solid var(--s2a-color-gray-1000);
  }

  .feds-popup .feds-gnav-cards:has(.featured-card) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    flex-wrap: unset;
    overflow-x: unset;
  }
}

/* =========================================
   Responsive: Large Desktop (min-width: 1280px)
   ========================================= */

@media (min-width: 1280px) {
  .feds-popup .feds-gnav-cards:has(.featured-card) {
    grid-template-columns: repeat(5, 1fr);
  }

  .feds-popup .featured-card {
    min-height: 307px;
  }
}

/* =========================================
   Hover: Desktop with pointer device only
   ========================================= */

@media (min-width: 1024px) and (hover: hover) {
  .featured-card a.feds-secondary-cta {
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  }

  .featured-card a.feds-secondary-cta:hover {
    background: var(--s2a-color-gray-1000);
    color: var(--s2a-color-gray-25);
    border-color: var(--s2a-color-gray-25);
  }
}
`);
        document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet];
      